<template>
  <div id="methane-page">
    <div v-if="'data' in pageContent && 'attributes' in pageContent.data">
      <div
        class="hero-banner-methane"
        :style="{
          backgroundImage: `url(${pageContent.data.attributes.BannerImage.data.attributes.url})`,
        }"
      >
        <div class="hero-banner-methane-content">
          <div class="content-container-1140 methane-overlap-conntainer">
            <div class="hero-banner-methane-content-inner">
              <h1>{{ pageContent.data.attributes.BannerTitle }}</h1>
              <p>{{ pageContent.data.attributes.BannerDescription }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="methane-intro">
        <div class="content-container-1140">
          <div class="methane-overlap-content">
            <h1>{{ pageContent.data.attributes.BannerTitle }}</h1>
            <p>{{ pageContent.data.attributes.BannerDescription }}</p>
          </div>
          <div class="methane-intro-stats d-flex align-center">
            <div class="methane-intro-stats-col methane-intro-stats-col-1">
              <div class="south-america-map toAnimate">
                <svg
                  id="svgMask"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 120.2 174.83"
                >
                  <defs>
                    <clipPath id="shapeClip">
                      <path
                        class="cls-1"
                        d="m15.91,155.23c.18.18.32-.28.52-.26-.11-.35-.55-.03-.52.26Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.22,151.54c-.2.15.17.13,0,.2,0,.44.43.14,0-.2Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.84,159.34c.1.13.13.49.33.47-.13-.29.16.09.01-.27-.15.06-.21-.43-.35-.2Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.58,160.39c-.04-.45-.55.19-.56.37.13-.05.53-.24.56-.37Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.31,160.68c-.12.1-.57.2-.42.41.21.08.4-.26.42-.41Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.62,150.11c-.02-.28-.33.06-.13-.26.04-.25,0-.88-.2-.27.12.19-.24.36-.02.1-.08-.09.11-.39-.09-.28-.04,0,.06-.12-.07-.17-.18-.05-.26.06-.23.22-.07-.11-.06-.28-.19-.09-.19.11-.36.12-.18.3-.36-.19-.29.37.1.11.25-.02-.21.1-.24.18.09.15.2-.04.08.22.13.21.41-.36.39.13-.05-.16-.22-.05-.31,0,0,.07.55.36.22.34.07.12,0,.2-.05.3.08.21.04,0-.01.17.08.88-.3-.29-.46-.12.05.1.19.19-.02.17-.09.05.07.27-.15.09-.14-.07,0,.27.12.23.1.04-.15.08-.16-.01-.47-.8-.3.1-.04.35.08.33-.4-.58-.49-.64-.33.12.08.63.13.61.15,0-.18.3.22.11-.34.34.16.13-.02.35-.19.14.21.34.16.57.01.23.58.65.39.19-.06,0,.34-.28.05-.28-.17.16.27-.47.05-.34-.14.26,0-.1-.14-.18.18.01.03-.29.15-.39.06.07.03.38.16.12-.02-.06.56-.16.24-.4-.01-.09.09.16.3-.12.22,0-.42.3.02.25-.25.04-.2.08-.19.29-.21-.4-.53.51-.06.22.09-.08-.08.19.08.13.15.11-.3,0-.36-.03-.08.09.18.28.06.25-.33-.19.08.22-.04.18-.06.35.09.07.25.08-.13.17-.27.35.1.25-.2.27-.49-.16-.4.35.17.11.4-.41.55.02-.15-.22-.33,0-.45.13-.07.07.09.19.04.07.11-.26-.02.21.19.13.19-.39.06.26.43-.16.16-.03-.09-.25-.11-.31.23.29.48.12.2-.14,0-.1.06.04.11-.02,0-.14.05.01.05.07.22-.46-.22-.35-.14-.49.53.08.02-.8-.18-.05.35-.76.29-1.77.27-2.57Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.01,158.27c.08-.06-.07-.34.05-.19.1-.25.12.27.22.32.27-.09.12-.28,0-.44.38-.01.06-.33-.24-.28-.32.12-.86.83-.14.41-.78.56-.44.74.12.18Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.15,156.04c0,.12.18.43.3.26-.15-.19.14-.47-.13-.48-.11-.07-.12.05-.06.11.12.19-.09-.01-.12.1Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.59,160.44c-.26.02.2.19.42.35.11.09.55.84.38.32.13-.44-1.24-1.34-.79-.67Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.67,161.85c-.15,0-.03-.2-.06-.3-.32-.07-.02.8.06.3Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.24,161.8c.17-.2-.57-1.03-.74-.75.08.26.39.42.58.6.12.03-.1.06-.11.09.03.1.19.15.27.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.13,159.99c-.69-.59-.14.28.11.49.25.13.19-.96-.11-.49Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.14,157.8c.26-.26-.1-.77-.17-1.08-.08,0,.02,1.17.17,1.08Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.86,162.68c.1-.07-.02-.4-.13-.45-.22.21-.11.31.13.45Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.25,158.47c.37.13.15-.24.04-.49-.32,0-.18.41-.04.49Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.76,161.97c-.13-.02-.18.07-.13.17.1-.06.31-.02.13.08-.27.39-.69.26-.34.74.21-.14.33-.46.58-.56-.51.57-.09.27.02.22-.18.24-.39.5.06.32.49-.31-.05-.57.2-.54.38-.42-.03-.58-.52-.44Z"
                      />
                      <path
                        class="cls-1"
                        d="m31.74,172.27c.65.34.36-.35,1.01-.23.39,1.66,1.95-1.58-.64-.93-.22-.15-1.79-.23-1.39.21.58-.07.27.19.39.77.12.31.56.02.58-.09.23.28.53.17.05.27Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.17,150.19c.25-.06-.04-.1-.08-.16.4-.04-.18-.44-.39-.42.17.21.04.79.46.57Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.99,160.61c.13-.35.12-.3.35-.72-.07.05-.35.22-.3.03-.04-.2-.45.74-.12.56-.4.31-.22.62.08.12Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.3,163.58c-.41.27.25-.05.35.01.4-.03.1.15.35.27.2,0,.13-.26,0-.33-.15.02-.28-.08-.41-.16.04.37-.08-.09-.3.21Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.89,155.26c-.1-.21-.27.08-.45-.23-.62.21.18.26.28.35-.27.26-.46.37-.12.73.24-.11.14.44.4.31-.07-.21.21-.19.17.02.4-.07-.12-.61-.38-.6.68.07.13-.06.11-.59Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.47,155.06c-.03-.15.37-.62.01-.49-.4.17-.67.94-.01.49Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.36,159.08c0,.06.11.26-.04.22-.6.03.74.79.52.26-.23-.05-.1-.79-.37-.65.06.16.12.2-.1.18Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.93,155.05c.11-.24.23-.33.39-.47.2-.23.73-.22.52-.57-.18-.04,0,.08-.12.13-.13-.01-.26.04-.42.09-.17-.04.33-.24.22-.36-.04-.05-.17.09-.19.14-.22-.04-.2-.59-.54-.18-.06-.32-.09-.16-.3-.09.06.21.36.37.54.41.2-.25.03.52-.15.28-.07.04-.4-.15-.21-.19.31-.01.02-.15-.11-.14-.55,1.33.09.34.16.67.6-.45-.49.52.2.28Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.75,151.71c-.18.08-.03.43-.02.61.37-.04.32-.45.02-.61Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.15,156.09c.06.08.16.33.28.28-.09.07-.4.23-.06.23-.22.36-.78-.25-.88.22.05.26.41-.26.19.38.19.13.26-.07.25-.23.4.15.02.05.06.34.29.16.33-.37.66-.31.07.1.19.49.13.12,0-.07.1.07.04-.19-.09-.38-.11-.85-.67-.84Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.24,155.59c.07-.05.19-.18.07-.24-.22-.15-.21.2-.07.24Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.8,158.42c.27.14.27-.15.09-.26-.16-.01-.08.16-.09.26Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.55,157.07c-.73.31.55.96.19.31-.61-.02.19-.27-.19-.31Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.21,159.89c-.36-.13-.15-.29-.66-.45.02.17.28.33.16.48.17.1.57.6.74.23.12-.23-.13-.01-.25-.14.15.02.18-.16.02-.12Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.92,160.69s-.16-.11-.15-.05c0,.09.1.13.15.05Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.75,156.08c.08.14-.18-.07-.24,0,.03.11-.02.18.12.23-.19,0,.04.07.11.09-.29.04-.18.06,0,.14.58.3.49-.44.34-.04,0,.01-.26-.24-.01-.17-.06-.1-.13-.21-.06-.33-.1-.18-.59-.07-.26.08Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.72,157.41c-.12-.2-.48.06-.32.19.1-.08.39,0,.32-.19Z"
                      />
                      <path
                        class="cls-1"
                        d="m22.98,168.25c.2.49.1.16.34.06-.23.17.04.5.03.15.22-.08-.08-.37.24-.32.05-.13.07-.06.03.04,0,.06.2-.01.04.07-.28.05.12.51.13.18.07-.09,0,.16.09.18.14-.15.24-.23.13,0,.08.11-.12-.03-.13.09-.39-.08.34.49.28.15,0,.37.4.07.08-.04-.13-.22.35.23.2-.07,0-.04.27-.08.07-.21.1-.03.06-.14.07-.25-.07-.02-.22.23-.06-.1.12-.2-.21-.46-.27-.17,0,.04.03.26-.08.18,0-.05.07-.25-.02-.24-.07.08-.08.53-.13.27.04-.16-.29-1.01-.32-.57,0,.07,0,.31-.1.15-.04-.12-.12-.61-.18-.23-.33-.28-.4-.05-.31.36.24.02-.19.2-.16.32Z"
                      />
                      <path
                        class="cls-1"
                        d="m21.61,167.92c-.03-.12-.22.03-.21.08.03.05.3.03.15.07-.42.08.15.04-.11.18-.27-.04-.41.22-.21.33.24-.02.04-.23.32,0,.08-.27.39-.41.05-.66Z"
                      />
                      <path
                        class="cls-1"
                        d="m22.11,168.12c.25.06-.31.02.15.26.61.02-.37.58.42.48-.28-.47.61-.06-.15-.74-.3-.79,0-.16.3.12.21-.11.43-.37.07-.31-.08-.24.11-.04.08-.34-.42.16,0-.06.11-.22-.33-.38-.51.45-.41-.02-.21-.35-.29-.22-.38-.13-.05.18-.2.22-.14.33-.09.01-.61-.48-.4.06.15,0-.05.23.02.3.09.33.26-.26.3.05.29.15-.27.1.02.16Z"
                      />
                      <path
                        class="cls-1"
                        d="m21.54,167.76c.16-.21-.23-.16-.17-.26.18.03-.22-.48.13-.13.01-.32-.15-.46.23-.18.12-.07,0-.27.21-.26.1-.08-.19-.15-.27-.18.23-.13-.24-.23-.27-.22-.19.31-.02.06-.19,0-.13-.2.19-.1.18-.23-.25-.41-.13.02-.59-.35-.1-.03.22.54-.03.48-.08-.23-.11-.63-.44-.79.13.29.04.54-.03.83-.24-.09.17-.62-.11-.6-.12.2.12-.42-.03-.29-.31-.23-.07,0-.13.18-.18-.1,0-.52-.42-.23.42.6-.08.25-.49.15-.23.03.15.4.29.35-.26.29.35.48.42.16.21-.1.07.02,0,.13,0,.19.48-.16.25.12-.64.17-.93-.61-1.45-.26-.22.34.63.2.09.51-.2.19,1.13-.36.59,0,.32.14-.09.29.04.4.28.33-.15.28-.03.45.3.12.86.34.47-.15.19-.74.03-.33.37-.24.13.08.48-.41.31-.03.32-.13.04.03.16.06.18-.07.32-.05.05.04-.54.36.06.29-.23.4.4.22-.48-.02.06.23-.15-.02-.83.09-.34.1.08.05.04.05.13-.01-.13.35.44.04.53-.15.05-.26.15.46.29.11.03-.73.13.06.46-.15Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.12,164.41c.2-.1.05.22.24.19-.04-.1-.04-.16.05-.05.19.48.15-.18.24.37,0,.1.27.07.19.16-.08-.01-.34-.08-.17.06.44.16.24-.32.55.09.17.11.94.09.32-.09.09-.23-.39-.12-.35-.22-.11-.1.16.01.09-.1-.21-.26-.54-.54-.34-.03-.29.42-.1-.56-.4-.59-.06.24.15.44-.2.05-.21-.19-.1.15-.34-.24-.15.05.02.17-.19.07-.11-.08.14-.01.03-.1-.07,0-.19-.2-.19-.04-.3-.29-.05-.09-.26.03-.07-.31-.27.02-.42-.23-.11.13-.24,0-.12-.13.07-.12-.05-.05-.12-.07-.08-.14-.49-.56-.61-.49-.34.19.36.26.27.48-.03.18-.06.25.15.28-.05.18.3.02.25.15,0,.08-.02.19.1.21.13-.24.04.38.18.14.13.07.14-.09.09-.17.11.01.17.29.29.2.04-.02.05.04.08.05.34-.09-.05-.16.12-.17.45.23.24-.16.49.2Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.1,165.5c-.17-.13-.73-.13-.33.15-.29-.06-.09.03-.09.13-.18-.03-.36-.23-.52-.25.05.12.6.61.6.32.12.35.08.18.33.11-.01-.29-.46-.25.02-.46Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.11,165.71c-.17-.26.08.22-.14.17.01.2.17-.12.08.25.31-.23.51-.21.06-.42Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.92,169.32c-.05-.01-.17.1-.11.14.21.05.47-.25.11-.14Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.59,167.9c-.18-.1-.35-.31-.68,0,.16.13.36-.17.33.11.07.2.19-.03.29.07.19.03,0-.1.06-.19Z"
                      />
                      <path
                        class="cls-1"
                        d="m21.14,168.86c.04.14-.14-.04-.07.12.06.04.1.3.19.21.01-.35.29,0,.19-.22-.04-.07.12.02.15.03.03-.07.03-.16-.08-.12-.36-.24-.06.08-.37,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m22.42,170.24c-.04-.13-.31-.44-.35-.17.12.22.06-.24.18.06.07.57.34.14.17.1Z"
                      />
                      <path
                        class="cls-1"
                        d="m31.26,173.38c-.05-.28.31-.24-.2-.28.24-.21-.2-.38-.34-.24.03-.47-.52-.15-.62-.19.13-.12-.1,0-.24-.32-.21.06,0-.08.09-.03.15.41.73.06,1.04.1.09-.14-.46-.14-.18-.2-.31-.26-1.89-.22-1.7-.77.15.22,1.35.8.93.2.11-.08.45.32.41-.1.06-.09.23.25.27-.02-.11-.84-1.8-.14-2-.11-.26-.2-.45-.06-.33.12-.06-.09-.27.07-.21-.04.04-.17-.35,0-.26.18.03.39-.08.19-.07-.08-.1-.36-1.5.38-.88.36.56-.01-.2.15.29.15-.03.11-.34.06-.1.12.15.23.52-.05.71-.2.35-.1-.03.17-.16.18-.16.12-.03.14.11.13.16.07-.11.01-.13.03-.28.12-.39.04-.07.21.3-.02.05.33.39.08.12.01.38.05.01.13.16.26.22.73.29.04.14.04-.02.57.29.3.1.04.32.32.16,0,0-.06.17-.11.03-.12-.13,0-.5.03-.18-.2.03-.11-.29-.09-.1-.23-.07-.02-.28-.22-.39-.07-.06-.56.08-.04.43-.35-.11-.39-.61-.07.07-.33-.11.15.29.67.27.36-.08-.06-.04-.35,0-.23.01.61.41.27.73.11-.21.23-.17.48-.39.71.04.07.7-.35.37-.09.22.27-.77-.03-.17.54.43.27.06-.57.35-.11.4.05.2-.23.31-.17.1.03.1.22.32.31.71-.25.25.46.51.44.37-.23.05.1.31.36.44-.1.06-.22.23-.32.12-.18-.11-.19-.21-.35Z"
                      />
                      <path
                        class="cls-1"
                        d="m27.1,171.34c-.08.32.14.05.25.12.25.03.66-.08.74-.19.04.13.44.03.27-.09.1.04.41.1.42,0-.48-.35-.75,0-.8-.1.15-.2-.36-.22-.48-.24-.27.08.06.08.08.19-.22-.1.1.16-.07.12-.18,0-.1-.07-.24-.26-.26-.04-.32.19-.04.25-.13.07-.4-.05-.14.21Z"
                      />
                      <path
                        class="cls-1"
                        d="m26.85,172.51c-.4-.22,0,.09.02.26.06-.08.25-.49-.02-.26Z"
                      />
                      <path
                        class="cls-1"
                        d="m27.57,172.9c.13-.01,0-.06,0-.12.26.08.15-.05-.02-.12-.28-.15-.22.34.03.24Z"
                      />
                      <path
                        class="cls-1"
                        d="m24.67,170.99c.04-.06.07-.13-.03-.09-.07-.2-.22.11-.34-.08-.11-.12-.39-.05-.59-.11-.19,0-.13.66.07.26.11,0-.12.23.03.19.15-.13,0-.33.26-.32.09.18.04.15.27.11.08.07-.04.04-.08.11-.07.06.14.04.18.1.09,0,.09-.17.18-.08.23,0,.12-.01.05-.09Z"
                      />
                      <path
                        class="cls-1"
                        d="m25.38,170.98c.1-.04.76-.06.53-.21-.18-.07-.84-.05-.69.15.07-.14.07.07.16.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m26.17,171.46c-.41.11-.49.01-.96-.05-.05-.25.32.1.3-.1.24.06.17,0,.24-.17.07,0,.39-.08.41-.16-.65-.16-.56.5-1.06.15-.11-.04.04.16-.16.11-.12,0,.07-.19-.07-.13-.18.06-.49.12-.09.21-.13.04-.3.13-.09.25.2.23.09-.15.35.1.26-.3.1.03.21.14.07-.04.31-.2.25-.24.01-.14.15.19.22.2-.33.07.08.68-.08.18.36-.04-.19.36.41,0-.41-.3-.01-.11-.11-.31.12.06.39.35.28.01-.34-.08.23-.07-.03-.21Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.32,159.47c-.12.05-.3.86-.05.58.2-.09.32-.64.05-.58Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.41,145.95c-.46.12.48.64.26.16-.02-.11-.18-.11-.26-.16Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.01,148.58c-.02-.16-.69-.39-.39-.08.05.3.21.25.39.08Z"
                      />
                      <path
                        class="cls-1"
                        d="m13.93,149.04c.06.16.54-.22.23.06.45-.22.13.18-.12.07-.13.37.81-.13.61-.35-.15,0,.07-.55-.09-.34-.06.12-.05-.23-.13.03-.06-.24-.12.07-.28.05-.17-.33-.36.33-.22.47Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.45,147.12c-.06.13-.07.13-.12,0-.4,0-.21.89.04.57.12-.05,0,.11-.03.14-.26.16-.22.25.03.23.28-.28,0,.1.22-.07.13.1-.28.21-.39.24-.12.57.64-.36.48.08.14.12-.01,1.39.4.86.43-.46-.18-.99-.29-1.44-.06-.12-.07-.84-.33-.61Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.37,164.88c-.15.04-.34.4-.07.28.2,0,.4-.47.07-.28Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.36,149.26c-.17.39.38.02.46-.1-.1-.04-.43-.07-.42,0,.07.15.07.03-.03.11Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.14,147.36c-.69-.44.08.58-.09.63.57,1.32,1.37-1.06.09-.63Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.92,149.64c.33.27.44-.52.3-.54-.07.19-.5.4-.3.54Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.64,150.54c-.27-.3-.11.02-.26-.02-.23-.24-.39-.08-.51.25.25-.25.87,1.17.76-.22Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.38,147.46c-.14.81.11-.16.08.61.59.07.29-.66-.08-.61Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.09,158.51c.03.23.12,0,.15-.1.15.01.28-.11.13-.27-.24-.11-.15-.14-.26.12.03-.83-.25.08-.2.38,0,.18-.31.13-.2.44.01.21.31-.05.23-.19.37.33.04-.51.17-.38Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.75,149.23c-.1-.16-.11.05-.11-.18-.46.44-.3.24-.72.3-.09.45.48.19.59-.03.03,0,.29.26.25-.09Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.78,159.23c-.35-.26-.08.2-.05.26-.04.08.12.17-.05.15,0,.14.23.46-.07.35-.05-.49-.42.35-.17.22.12.05-.37.15-.11.32.27.07-.13.49.2.13-.18.49.17-.01.13-.19.17-.28.46-1.2.12-1.24Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.16,161.84c.32.09.35-.48.19-.63-.23-.12-.5.21-.64-.07-.34.05.27.34.12.56.24.18.11-.24.33.14Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.77,156.21c-.08-.19.11-.31-.06-.42.24-.02-.27-.37,0-.3.06.34.6-.18.4-.21-.25-.02-.3.11-.43-.09-.09-.04-.06.2-.12.07-.08-.2-.12.02-.24.03.02.09.31.26.2.33.05.14-.25-.04-.22.18-.33.1.44.09.06.21-.04.03.08.12.02.12-.13.21.28,0,.26.03-.05.11.06.18.12.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.34,150.13c-.32.43.1.25.22,0,.02.12.09-.05.14.02-.04.19.24.62.23.19-.09-.2-.37-.93-.38-.32-.17-.08.04-.43-.15-.18-.03.06-.1.16-.19.15,0-.05.23-.25.07-.2-.15-.07-.06.03-.19.05-.03.02-.2.02-.18.23.01.29.3.16.44.07Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.13,151.1c.22.22.2-.26.33-.37-.12.42.58-.26.11-.31.21-.6-.36.4-.39.32-.09.07.02-.08.01-.09-.28.2-.38.41-.06.45Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.62,152.88c-.24.12.32.63.16.2.58.61-.12-.82-.36-.86-.25-.18-.57.34-.18.45-.49.2-.29.63.14.19.21-.14.18-.28.23.02Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.17,161.33c.15.23-.08.32.26.53.19-.16.43-.17.39-.32-.26-.21-.66-1.03-1.03-.66-.16.25.61.09.54.26-.26-.08,0,.09.08.12.15.21-.2-.12-.24.07Z"
                      />
                      <path
                        class="cls-1"
                        d="m71.89,28.58c-.02.38.07.08.09.17-.12.46.56-.07.77.36,1.08-.64,1.68-1.18-.07-.76-.13.32-.59.05-.79.23Z"
                      />
                      <path
                        class="cls-1"
                        d="m72.3,27.39c.17.1.58-.31.33-.33-.19-.16-.81.4-.33.33Z"
                      />
                      <path
                        class="cls-1"
                        d="m72.93,26.7c-.09.06-.57.25-.31.32.14-.03.35-.18.31-.32Z"
                      />
                      <path
                        class="cls-1"
                        d="m73.15,29.22c.33.14.97.13,1.11-.18-.12-.39-.96-.17-1.11.18Z"
                      />
                      <path
                        class="cls-1"
                        d="m72.05,28.11c.07.35.97-.35.53-.5-.14.19-.6.01-.53.5Z"
                      />
                      <path
                        class="cls-1"
                        d="m71.8,27.79c.06.3-.48,1.18.1.69.2.02.11-1.06-.1-.69Z"
                      />
                      <path
                        class="cls-1"
                        d="m71.07,28.93c-.41-.11-.93.51-.54.7.11.18,1.22-.47.54-.7Z"
                      />
                      <path
                        class="cls-1"
                        d="m70.25,30.77c.17-.2.71-.13.63-.44.1-.27-.83.1-.63.44Z"
                      />
                      <path
                        class="cls-1"
                        d="m71.31,28.85c.18.33.67.18.38-.16-.22-.1-.48-.15-.38.16Z"
                      />
                      <path
                        class="cls-1"
                        d="m46.93,10.59c.03.16.82.02.56-.16-.1-.02-.34.05-.25.16-.1-.06-.23-.16-.31,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m73.85,32.66c-.03.22.46-.11.11-.1-.06.01-.13.02-.11.1Z"
                      />
                      <path
                        class="cls-1"
                        d="m48.22,9.99c-.09-.29-.33-.07-.58-.04-1.33.43.39.71.58.04Z"
                      />
                      <path
                        class="cls-1"
                        d="m48.61,4.45c-.19.09-.66.21-.71.43.2-.03.8-.15.71-.43Z"
                      />
                      <path
                        class="cls-1"
                        d="m47.95,9.14c-.11.3-.03.17.11.04.2.02-.03-.17-.11-.04Z"
                      />
                      <path
                        class="cls-1"
                        d="m72.27,28.43c-.02.09.24-.06.29-.09.04-.17-.26.03-.29.09Z"
                      />
                      <path
                        class="cls-1"
                        d="m71.8,25c.37-.04.22-.56-.08-.53-.29.05-.09.44.08.53Z"
                      />
                      <path
                        class="cls-1"
                        d="m53.54,13.98c-.11-.03-.21.09-.19.19.04-.07.45-.17.19-.19Z"
                      />
                      <path
                        class="cls-1"
                        d="m71.75,24.45c.24-.08-.3-.24-.23-.06.12.11.07.08.23.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m72.2,32.52s0,.02,0,.02c0,0,0,0,0-.02,0,0,0,0,0,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m87.51,34.21s.12-.16.02-.13c-.13,0-.13.1-.02.13Z"
                      />
                      <path
                        class="cls-1"
                        d="m90.81,34.96c.16-.02-.18-.12-.22-.17-.22-.03.1.2.22.17Z"
                      />
                      <path
                        class="cls-1"
                        d="m91.02,34.81c-.1-.09-.55-.07-.14,0-.05.12.23.18.14,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m87.38,33.84c-.2-.03-.35.3-.2.38.13-.05.34-.27.2-.38Z"
                      />
                      <path
                        class="cls-1"
                        d="m113.13,37.25s-.16.07-.12.1c.04,0,.24-.1.12-.1Z"
                      />
                      <path
                        class="cls-1"
                        d="m87.09,34.26c-.02-.08-.08-.02-.11.02-.01-.08-.12-.17-.07,0-.1.19.18.15.17-.01Z"
                      />
                      <path
                        class="cls-1"
                        d="m120.16,74.22s.06-.04.01-.07c-.06-.02-.03.05-.01.07Z"
                      />
                      <path
                        class="cls-1"
                        d="m120.12,27.19c.08-.07-.05-.13-.12-.09-.11.07.04.16.12.09Z"
                      />
                      <path
                        class="cls-1"
                        d="m74.14,29.54c-.12-.14-.42,0-.58-.03-.9-.55-3.41-.12-2.05.94-.21.05-.35-.13-.43-.27-.12.34-.39,1.51.41,1.07.04-.01.07-.02.09-.03.04-.03.09-.03,0,0-.04.03-.08.07,0,.13-.11.04-.31,0-.11.13-.6-.09-.54-.36-.5.51-.11.07.06.16.07.24.84.67-.12.54.87.7.41-.02-.14-.15.14-.12.14,0,.03-.2.02-.26.13.2.07.24.14-.01,0,0,0-.02,0-.02-.23-.14.04-.1-.07-.27.06-.04.05.11.07.27,0,0,0,0,0,0,0,0,0,0,0,.02.02.13.07.25.21.28.1-.05.28-.11.23-.25.02.03.32.29.56.33.34-.02,0-.44.16-.48-.14.39.45.42.43.14.13-.11.08-.53.15-.23-.05.19.45.28.26.06-.13-.02-.07-.22-.02-.2-.12.23.5.36.46.21-.09.05-.12-.11-.03-.04.01-.03,0-.37,0-.39.32.57,1.15.09.49-.08-.04-.07.18-.12-.03-.14.14-.08.25.25.36.27.23-.36-.06-.31,0-.39-.34-.29.08.07.45-.32-.03-.44.08-.16.27-.51-.12-.48.06-.04.14-.58.44-.87-.04-.7-.99-.77.04-.21-.67-.12-.93-.13-.19-.01-.25.14-.23.21Z"
                      />
                      <path
                        class="cls-1"
                        d="m76.29,31.5c.18.2.51.04.28-.21-.17-.04-.23.11-.28.21Z"
                      />
                      <path
                        class="cls-1"
                        d="m71.57,31.23c.09-.03.04-.03,0,0h0Z"
                      />
                      <path
                        class="cls-1"
                        d="m48.43,10.34c.04-.13-.22,0-.18-.16.09-.15-.06.03-.13.02-.38.23.18.22.31.14Z"
                      />
                      <path
                        class="cls-1"
                        d="m74.04,33.01c.15.14.4-.12.35-.23-.12-.22-.38.11-.35.23Z"
                      />
                      <path
                        class="cls-1"
                        d="m76.88,31.19c.08-.18.18-.31.03-.43-.22.07-.47.57-.03.43Z"
                      />
                      <path
                        class="cls-1"
                        d="m84.43,31.89c0-.11.14,0,.05-.16-.28-.13-.2.25-.24.12-.13-.11-.08.33.19.04Z"
                      />
                      <path
                        class="cls-1"
                        d="m78.13,30.24c-.16-.08-.35-.03-.13.12.06.34.28.05.13-.12Z"
                      />
                      <path
                        class="cls-1"
                        d="m77.47,30.38c-.08-.07-.09.11-.04.16.07.1.3-.21.04-.16Z"
                      />
                      <path
                        class="cls-1"
                        d="m34.34,3.52s-.22.06-.23.07c.06.03.36-.11.23-.07Z"
                      />
                      <path
                        class="cls-1"
                        d="m2.01,42.74c-.06-.03-.1.25,0,.2.01-.07-.06-.14,0-.2Z"
                      />
                      <path
                        class="cls-1"
                        d="m2.24,105.99c-.09.04-.1.14-.04.21.17.1.17-.17.04-.21Z"
                      />
                      <path
                        class="cls-1"
                        d="m3.7,87.56s.06,0,.03-.02l-.03.02Z"
                      />
                      <path
                        class="cls-1"
                        d="m6.27,105.95c.1-.14.64.03.46-.15-.16-.12-.39-.04-.46.15Z"
                      />
                      <path
                        class="cls-1"
                        d="m4.18,87.76s0-.02,0-.03c-.01.02-.02.03,0,.03Z"
                      />
                      <path
                        class="cls-1"
                        d="m8.1,22.57s-.11.13-.05.13c.09.01.15-.22.05-.13Z"
                      />
                      <path
                        class="cls-1"
                        d="m8.11,23.53c.17.21.28-.05.12-.18-.08-.31-.3.02-.12.18Z"
                      />
                      <path
                        class="cls-1"
                        d="m.77.12c.07,0,.12-.09.04-.12-.04.02-.05.08-.04.12Z"
                      />
                      <path
                        class="cls-1"
                        d="m.25,20.49c.05,0,.12-.09.02-.06,0,.03-.06.04-.02.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m.02,1.88c-.05.15.1-.11.05-.15-.06.03-.08.1-.05.15Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.9,146.43c-.45.2-.97.13-1.11.69.19.19.31-.16.5-.13,0,.17.92.55.68.18.03-.15-.36-.07-.06-.17-.07-.2.1-.34,0-.57Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.96,147.72c-.39.62.34.69,0,.9-.17-.02-.04-.43-.24-.28-1.25.39,1.01,1.42.85.59-.33.38-.1-.48-.4-.54.2-.05.27-.08.13-.27-.22-.08-.26-1.16-.33-.39Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.04,143.15c.28-.18-.13-.42-.37-.3-.09.12.3.17.37.3Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.22,146.38c-.18.04-.07.4.07.4.01-.23.55-.31-.07-.4Z"
                      />
                      <path
                        class="cls-1"
                        d="m12.72,60.02s-.03-.04-.04-.06c-.13-.04,0,.11.04.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m12.04,59.06s.11-.02.06-.05c-.02-.05-.06.03-.06.05Z"
                      />
                      <path
                        class="cls-1"
                        d="m10.29,55.12c-.11-.04.02.1.06.11.12.01-.04-.07-.06-.11Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.99,146.49c-.36.13.63-.02.26-.17-.02-.06-.16.09-.11-.03.14-.03.14-.11.09-.22-.1-.21-.16.17-.56.02-.26.31.26.12.31.4Z"
                      />
                      <path
                        class="cls-1"
                        d="m8.9,23.32c.12.09.29.11.07-.04,0-.1-.17-.16-.18-.1,0,.03.02.06.04.08.03.02.05.04.07.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m37.83,5.32c-.14-.03-.36-.11-.42.06.14.1.65.12.42-.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m35.73,3.51c.1.04.14-.12.03-.09-.15-.02-.16.04-.03.09Z"
                      />
                      <path
                        class="cls-1"
                        d="m34.66,3.5c.05-.2-.11.09-.22,0,.04.08.34.02.22,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m39.26,3.43c.19.04.12-.14,0-.18-.07.07-.15.18,0,.18Z"
                      />
                      <path
                        class="cls-1"
                        d="m34.38,3.31c-.18-.02-.25,0-.02,0,.04,0,.1-.01.02,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m40.52,5.47c.02.1.44-.02.49-.18.22.08.02-.21,0-.37-.18-.23-.35.22-.46.32-.5-.06-.14-.26-.56-.2-.72.36.34.23.54.43Z"
                      />
                      <path
                        class="cls-1"
                        d="m40.87,5.71s-.12-.05-.17-.07c-.23.05.27.28.17.07Z"
                      />
                      <path
                        class="cls-1"
                        d="m8.8,23.31c.05.25.22.16.1.01-.03-.02-.05-.04-.07-.06-.02-.02-.05-.04-.08-.06-.09,0-.02.13.05.11Z"
                      />
                      <path
                        class="cls-1"
                        d="m40.26,5.6s-.08,0-.11.02c-.04.1.22.04.11-.02Z"
                      />
                      <path
                        class="cls-1"
                        d="m14.11,6.65c.15.04.01-.12-.04-.05-.05.07,0,.15.04.05Z"
                      />
                      <path
                        class="cls-1"
                        d="m47.54,7.1c.08-.33-.24-.97-.01-1.23.64-.68-1.21-.02-1.41-.09-.34.17.29.09.33.32.16.76-.22.76-.82,1.07-.52.15,1.59.11,1.92-.07Z"
                      />
                      <path
                        class="cls-1"
                        d="m8.9,23.32s-.04-.04-.07-.06c.02.02.04.04.07.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m26.89,1.76c-.2-.21-.11-.08-.14.09.38.34.58.26.14-.09Z"
                      />
                      <path
                        class="cls-1"
                        d="m29.68,2.81c-.3-.23-.59-.36-.86-.64-.26.27,1.07,1.04.86.64Z"
                      />
                      <path
                        class="cls-1"
                        d="m32.26,3.06s-.06-.01-.02,0c.04.01.1,0,.02,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m30.83,2.87c.11.32.22-.29.16-.34-.23.02-.42-.35-.47-.06.21.2.33-.03.31.41Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.57,148.16c.65.57.67.33.37-.22-.35.06.13.41-.21.21-.05-.02-.12-.01-.16.01Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.47,138.97c-.62.29-.03,1.34.13.78-.35-.14.41-.54-.13-.78Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.94,136.73c.1,0-.02.02-.06.03-.18.55,1.37-.02,1-.26-.24-.21-1.64,0-.94.23Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.13,136.53c-.29.35.88.3.36.12.31-.34-.48-.63-.36-.12Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.97,137.41c.46.46.16-.78-.11-.42.28.53-.2-.02.11.42Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.61,136.86c-.08-.1-.2.06-.31.03-.11.24.32.46.31-.03Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.33,135.89c.16.12.14-.1,0-.11.05,0,.18.03.17-.06.01-.14-.48.03-.16.17Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.13,132.67c-.08.03-.04.13-.07.2.15.07.09-.11.07-.2Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.89,135.05c-.23.1.37.2.19.01-.03-.03-.15,0-.19-.01Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.29,134.47c-.06.2.17.39.22.53.19-.13-.08-.65-.22-.53Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.48,132.36c.06-.05.02-.18-.07-.17-.17-.06-.02.15.07.17Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.02,134.64c-.16.08.17.04.21.02-.03,0-.17-.03-.21-.02Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.01,133.92c-.1.3-.42-.03-.64.17-.17.25.29.21.4.32.36-.14-.3-.21.18-.28.05.36.55.1.06-.21Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.08,135.44c0,.13-.22.03-.29.02-.09.09.14.18.22.15.22.05.19-.29.06-.18Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.82,136.11c-.14-.19-.83-.27-.2,0-.63.07.34.37.2,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.95,136.16c-.41.24.75.26.31-.07-.1.04-.22,0-.31.07Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.19,135.88c-.15,0-.14-.22-.26-.13-.15.24.28.38.26.13Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.64,135.67c-.33-.28-.15.19.1.19.22.24.19-.35-.1-.19Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.46,135.29c.2.62.12,0,.49.04,0-.11-.18-.06-.23-.11-.04-.03-.12-.2-.18-.14.17.26-.22-.04-.08.22Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.98,134.96c-.37-.18-.36.34.08.22.09-.1,0-.1-.08-.1,0-.05.06-.06,0-.11Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.4,135.49c.15-.11.01-.22-.1-.08-.09-.1-.02.21.1.08Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.48,134.64c.23.17.14-.2.2-.32-.16-.25-.53.25-.2.32Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.57,129.42c-.1.23.4.25.23,0-.14-.06-.09.22-.23,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.3,130.54c-.23-.06,0,.1.11.09.14-.06-.03-.1-.11-.09Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.4,135.78c.25,0,.21-.14.03-.25-.12.03-.18.21-.03.25Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.12,136.38c-.34.08-.09.42-.02.61.09-.05.6-.08.32.08-.39-.19-.34.2-.05.38.63-.26,1.23-.65.77-.97.78.31.38-1.06-.03-.32-.14-.05.26-.27-.11-.46-.4.11.03.28-.11.33-.02-.1-.14-.18-.2-.09-.11-.3-.42.12-.19.23.07.04.28.02.19.14-.72-.31.13.49-.36.12-.1-.02-.12.07-.2-.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m20.17,130.92c-.03-.29-.05.11-.19-.18-.17.02.26.54.19.18Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.41,139.8c-.01-.14.07-.31.02-.41-.5-.04-.39.91-.02.41Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.8,127.99c0,.1.05.19,0,.28.34.25.1-.38,0-.28Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.98,118.45c-.17-.2-.21-.08-.1.1.07.12.17-.02.1-.1Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.11,138.45s0,0,0,0c-.02,0-.04,0-.06,0,.02,0,.04.01.06.01Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.64,138.4c-.02-.22-.34-.11-.31.06-.01.32,1.15.37.78,0-.02,0-.04,0-.06-.01-.13-.01-.32.06-.41-.04Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.08,139.58c-.11-.08.18-.01.11-.17-.07-.06-.27-.71-.52-.27-.14.31.12.46-.12.73.02.33.59-.07.33-.11.12,0,.54-.21.2-.19Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.68,138.94c-.14-.13-.33.31-.25.36.23.29.02-.03.25-.36Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.11,138.45c.13.01.22-.03.21-.16.24-.64-.47-.67-.96-.58-.44.19-.19.57.15.36.05.17.32.33.54.38.02,0,.04,0,.06,0,0,0,0,0,0,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.06,130.25c-.09-.21-.7-.79-.46-.22.48.13.4.47.46.22Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.28,130.5c.1.07.42.12.33-.1-.03-.03-.37.03-.33.1Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.6,131.45c.18,0,.28.14.43.18.4.02-.4-.35-.43-.18Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.97,139.35c.13-.02.26-.49,0-.28-.35-.28-.58-.07-.59.32.2-.26.29-.18.59-.04Z"
                      />
                      <path
                        class="cls-1"
                        d="m4.42,34.53c.11-.1-.04-.11-.06-.19-.14.21-.24.55.06.19Z"
                      />
                      <path
                        class="cls-1"
                        d="m6.46,26.05c-.08.07-.34.2-.13.3.15-.05.17-.12.13-.3Z"
                      />
                      <path
                        class="cls-1"
                        d="m9.56,19.96c.14-.07.93-.04.45-.13-.12-.25-.28-.08-.2,0-.02.03-.27,0-.25.13Z"
                      />
                      <path
                        class="cls-1"
                        d="m44.55,7.44c.07-.01.2-.06.13-.15-.07,0-.14.09-.13.15Z"
                      />
                      <path
                        class="cls-1"
                        d="m44.49,7.74c.02-.05.03-.12-.01-.17-.07-.04-.05.18.01.17Z"
                      />
                      <path
                        class="cls-1"
                        d="m21.11,128.89c-.22-.09-.31.19-.06.23.13.09.08-.17.06-.23Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.98,114.91c-.09-.04-.2-.28-.22-.19-.03.3.03.12.22.19Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.06,137.39c.35.07.32-.23.14-.38-.29-.31-.18.26-.14.38Z"
                      />
                      <path
                        class="cls-1"
                        d="m3.81,34.72c-.12.07-.35.07-.38.22-.6,1.41,1.3-.26.38-.22Z"
                      />
                      <path
                        class="cls-1"
                        d="m69.55,29.94c.16.21.88-.6.54-.63-.3.13-.28.47-.54.63Z"
                      />
                      <path
                        class="cls-1"
                        d="m107.55,45.83c0-.07.08-.25-.03-.25-.03.08-.17.28.03.25Z"
                      />
                      <path
                        class="cls-1"
                        d="m44.25,7.4c0,.1.14.04.06-.01-.03-.12-.1-.11-.06.01Z"
                      />
                      <path
                        class="cls-1"
                        d="m98.73,57.05c.09.13-.36.19-.24.38.04,0,.57-.29.39-.43-.16-.19-.15-.08-.16.04Z"
                      />
                      <path
                        class="cls-1"
                        d="m85.15,35.54c.2-.07.33-.51.24-.51.02-.6-.26.36-.24.51Z"
                      />
                      <path
                        class="cls-1"
                        d="m43.42,6.43c.04.08.45.43.29.18-.08-.05-.29-.42-.29-.18Z"
                      />
                      <path
                        class="cls-1"
                        d="m47.67,9.23c-.05.2-.05.24.15.1.13-.09.04-.26-.15-.1Z"
                      />
                      <path
                        class="cls-1"
                        d="m46.9,10.78c.08-.1-.12-.29-.26-.28-.67.04.06.09.26.28Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.83,133.52c.12.23.37-.04.6-.02-.18-.31-.67-.33-.6.02Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.92,138.66c-.02-.19-.4-.26-.42-.07.06.19.63.44.42.07Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.87,139.92c-.48-.08-.41.19-.2.52.22-.14-.01-.4.2-.52Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.69,138.8c-.11.17.37.2.42.05.02-.12-.33-.09-.42-.05Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.91,139.44c-.28-.35-.6,0-.37.31.2.26.49-.07.37-.31Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.69,139.58c.11.17.43.37.2,0,0-.12-.24-.14-.2,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.75,138.39c.25.31.25.09.32-.12-.21-.19-.37-.23-.32.12Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.51,136.82c0,.4.66.47.42.22-.25-.01-.08-.44-.42-.22Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.8,137.05c.04-.24-.39-.01-.52-.01.12.11.46.24.52.01Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.94,132.47c.17.11.55.38.65.24.27.09.03.05.28,0,.06.06.12.24.22.15.1-.05.08,0,.08-.16.09.12.42.1.24-.06-.19-.15.16.03.05-.18-.13-.1-.3-.45-.15-.51,0,.21.24.02.35,0,.14.12.32.03.14-.1-.04-.07-.21-.04-.18-.11.46.17-.18-.4-.23-.5.43.2.74-.21.17-.37-.18-.27-.43-.33-.44-.66-.02-.09.23-.25.13-.08-.19.24.65.15.2-.05-.16-.48.47-.4.68-.52.14-.38-.47-.36-.14-.67,0-.09-.46-.43-.21-.39,0-.21.12-.32-.15-.37-.05.13-.46-.02-.36.25.01.14-.11-.15-.17-.06.02.17-.51,0-.36-.12.3.2.28-.25.09-.03-.51-.27.03.17-.23.39-.02.1,0,.23.02.33-.39.65-.24,1.32-.24,2.05-.13.08.1.42-.17.45.06.27-.13.13-.01.32-.13.1-.62.79-.24.76Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.81,137.55c.26-.24-.67-.48-.72-.09-.58.34.32.17.54.15-.17-.18.12.05.19-.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.06,140.47c.24-.26.46,0,.24-.4-.53.15-.53.93-.24.4Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.81,136.26c-.12-.19.06-.11.21-.19.44-.02-.09-.54-.27-.04-.27-.39-.5.29.06.23Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.86,136.64c.16.09.24-.39.06-.28-.07-.28-.18.2-.06.28Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.21,136.68c.14,0,.65.13.39-.15-.14-.08-.53-.05-.39.15Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.12,140.61c.09.27.4.16.26-.14-.2-.08-.13-.12-.26.14Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.34,140.86c-.77-.32-.35.15-.19.44.16.09.4-.37.19-.44Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.02,135.54c.08-.13-.08-.23-.2-.18-.22.11.13.13.2.18Z"
                      />
                      <path
                        class="cls-1"
                        d="m26.26,168.63c.27-.17-.06-.35-.26-.31-.51-.42-.34.31.26.31Z"
                      />
                      <path
                        class="cls-1"
                        d="m48.6,157.97c-.06-.07-.19-.15-.12,0,.09.06.23.15.12,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m49.43,158.35c.16.14.38-.28.16-.33-.33.16-.42-.24-.46-.07.14.11.66.47.22.24-.33.01-.17.28.08.17Z"
                      />
                      <path
                        class="cls-1"
                        d="m50.01,158.16c.06-.05-.06-.09.04-.12-.31-.21-.35.19-.04.12Z"
                      />
                      <path
                        class="cls-1"
                        d="m45.23,120.25c-.12-.11-.45.07-.19.02.08.13.41.15.19-.02Z"
                      />
                      <path
                        class="cls-1"
                        d="m50.67,159.56c.34-.84.56-.08.6-.81-.02-.14.1.02.14-.06.23-.25.12-.06.06-.2.33-.19-.09-.11-.2-.3-.38-.09.19.59-.49.32.59-.34-.29.1-.5.03-.13-.12.01-.04.09-.09-.03-.05-.3-.04-.27-.1.05-.05-.01-.05-.05-.07-.42.31-.08-.21-.4.17.46.29-.3.25-.57.1-.18-.17-.93-.63-.66-.12.24.02.82.27.24.22-.12.21.61.33.73.6.61.23-.15,0-.41.05-.29.3-.63-.16-.62.14.39.54.13.15.43.19.25-.28.98-.2.45.05-.07-.22-.17,0-.12.12,0,.05-.07.22-.16.1.04-.08.09-.2-.06-.14.14-.11,0-.14-.09-.05-.06.17.06.39-.14.49-.36.02-.09.11.09.02.42-.26-.17.44-.46.11-.08.14-.08-.03-.21-.02-.45,0-.03.09.04.19-.11.08-.38,0-.27.19-.08-.07-.14-.14-.31-.17-.43.1,1.16.89.4.35-.06-.08.24-.04.27-.04.09.07-.12.1.11.28.08.05,0,.04-.05.03.1.37.66-.07.29-.23-.03-.11.09-.04.13,0,.6.42.36-.5.7-.57-.2.18.17.09.28.08-.02-.07-.02-.27.07-.13.38.34.6-.56.94-.75Z"
                      />
                      <path
                        class="cls-1"
                        d="m47.24,157.22s.22.11.16.02c-.12-.12-.12-.21-.16-.02Z"
                      />
                      <path
                        class="cls-1"
                        d="m46.81,159.84c.2.29.18.08.27-.02-.1-.15-.09.09-.27.02Z"
                      />
                      <path
                        class="cls-1"
                        d="m46.91,159.35c-.12.03-.16.23-.02.26-.1-.23.37-.2.02-.26Z"
                      />
                      <path
                        class="cls-1"
                        d="m47.86,159.65c-.18-.08.12.25-.4.36.28-.36.25-.38-.25-.13,0,.12.19.47.43.4.28-.07.09-.37.21-.63Z"
                      />
                      <path
                        class="cls-1"
                        d="m50.39,158.26c.04.11.06.2.29.06.22-.06-.25-.11-.27-.19-.12.04-.29.17-.02.14Z"
                      />
                      <path
                        class="cls-1"
                        d="m54.83,159.39c-.44-.08.04-.06.11-.18-.04-.2-1.36-.29-.6-.37-.14-.3.6.28.58-.05-.05.01-.2-.56-.43-.52-1.12.16-.93.24-.48.83-.31-.18-.03.08-.13.14-.11-.06-.11-.19-.14-.3-.55-.12-.14-.07-.36-.32-.31.29-.17-.62-.03-.14.14.16.38-.06.26-.23-.39-.47-.94.11-1.4-.41.47.62-.13.39-.38.67-.04.12.26.13.31.23-.26-.1.02.18-.09.26-.23-.23-.1-.36-.32-.04.04.19.4.18.4.32-.25.07.24.49-.12.53.14-.52-.23-.52-.6-.24.12.27-.16,0-.14.26-.21-.01-.25.13-.36.22.32.33-.08.04-.19.12-.07.15.4.13.07.2-.06.02-.01.03,0,.07.12.21-.23-.1-.12.12.22.09-.06.41-.18.23-.22.09,1.14,1.18.76.72.16-.31-.14-.2-.19-.55.08-.09.13.16.14-.04.15-.13.39.33.65.33.25.06-.03-.16.16-.31-.08,0-.31.13-.25-.04.14-.06.21-.15,0-.12.1-.09.07-.14-.07-.09-.02-.1-.04-.17-.18-.17-.21.12-.07-.2.09-.03.36-.27.69.65.85.11.23-.09.62.56.39,0,.02-.03.12-.1.16-.12-.1-.32-.44-.03-.48-.3-.17-.05-.57-.37-.25-.37.12.26.56.35.83.27.31.04.63-.06.86-.26-.08-.02-.48.11-.33.05.07-.12.64-.11.31-.15-.4-.16.33-.03.47-.1.06-.05.92-.29.4-.2Z"
                      />
                      <path
                        class="cls-1"
                        d="m53.46,160.44c-.39-.01-.3.29-.02.36-.06-.09.04-.23-.09-.21.02-.07.18-.04.1-.15Z"
                      />
                      <path
                        class="cls-1"
                        d="m50.97,157.9c-.08-.01-.1.18-.16.05,0-.13-.86-.12-.41.02.22,0,.95.4.57-.07Z"
                      />
                      <path
                        class="cls-1"
                        d="m76.61,85.43c-.06.05,0,.26.07.25.1-.06.15-.49-.07-.25Z"
                      />
                      <path
                        class="cls-1"
                        d="m83.62,81.78c.36-.73-1.08.44-.03.2.09.2.12.03.15-.04-.05-.06-.17,0-.12-.16Z"
                      />
                      <path
                        class="cls-1"
                        d="m50.36,161.05s-.06-.2-.07-.06c.11.14.13.24.08.41.01.05.29-.16.16-.21.07-.14-.03-.18-.16-.15Z"
                      />
                      <path
                        class="cls-1"
                        d="m50.35,161.61c-.24.15.17.32.19.23.03-.05.14-.07.08-.13-.41.21.12-.42-.26-.1Z"
                      />
                      <path
                        class="cls-1"
                        d="m50.47,160.38s.15.06.09-.04c-.05-.16-.07-.09-.09.04Z"
                      />
                      <path
                        class="cls-1"
                        d="m76.36,90.29c-.39.13-.11.5-.3.81-.05.66.66-.9.3-.81Z"
                      />
                      <path
                        class="cls-1"
                        d="m34.7,172.41c.16,0,.35-.26.38-.36-.28-.23-.72.24-.38.36Z"
                      />
                      <path
                        class="cls-1"
                        d="m33.43,174.72c.23.29.12-.09.12-.23.09-.24-.34.13-.12.23Z"
                      />
                      <path
                        class="cls-1"
                        d="m33.63,172.58c.16.06.67.02.47-.21.02-.35-.66-.12-.47.21Z"
                      />
                      <path
                        class="cls-1"
                        d="m33.61,171.43c.28.08.83.66.45,0-.11-.03-.51-.24-.45,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m32.84,174.53c.06-.03.64.49.36.01-.03-.12-.47-.15-.36-.01Z"
                      />
                      <path
                        class="cls-1"
                        d="m32.29,173.23c-.15-.1-.15.13-.09.21-.38.54.55.09.09-.21Z"
                      />
                      <path
                        class="cls-1"
                        d="m32.61,174.47c-.3-.21-.02.18-.27.02-.19-.01-.9-.12-.59.23.2.05.16-.07.33-.12.05.27.06,0,.23.02-.15.33.24.18.23-.07.19,0,.14-.19.07-.08Z"
                      />
                      <path
                        class="cls-1"
                        d="m32.96,174.05c-.03-.17.06-.37-.02-.52-.37.05.03.34-.14.51-.29-.54-.59.31.1.17.23.37.42-.17.06-.15Z"
                      />
                      <path
                        class="cls-1"
                        d="m33.38,174.33c.08-.09-.09-.13-.15-.05-.04.19.06.02.15.05Z"
                      />
                      <path
                        class="cls-1"
                        d="m37.48,170.02c-2.18.23-4.09-2.08-5.32-3.15-.9-.51-.53-1.79-1.63-1.78-.55-.11-.32-.66,0-.9.33-.36.3.03.41.25-.01-.52-.92-2.26-1.39-1.84-1.09.9-.8-.66-1.54-.41-.32.06-.28.32-.19.54-.95,1.56-1.16-.21-1.89.49.37-.07.4.27.26.49,1.17-.63-.07,1.18-.06.28-.32-.24-.52,1.42.11,1.65.59.06,1.28-.48,2.02-.35,1.4,1.14-5.02,1.15.27,3.54.12.25.83.27.62.56-.65-.32-.2.28-.39.38-.1-.43-.48.15-.43.34-.39-.01.39-.65.29-.83-.17-.08-1.01-.7-.66-.1-.1.27-.37-.61-.76-.5-.1.35.36.62.23.99-.17.08.03-.55-.27-.18-.05-.08.04-.42-.15-.47-.1.06-.02-.09-.09-.15.03-.44-.35-.26-.51-.04.32.31.28.01.14.4-.12-.18-1.96-1.37-1.72-.98.26.09-.27.16.19.4.88-.15.7.78,1.5.97.11.13-.6-.27-.18.08-.11.15-.52-.43-.75-.51-.13-.31-.51.47-.17.69-.12.07-.23-.24-.26-.14-.01.15-.07.15-.08,0,.04-.21.44-.84.31-.86-.21.1-.4-.19-.64.05-.12-.04.07.28-.08.36.06.21-.23-.06-.36-.03-.13-.01.08.24.08.29-.17-.18-.46-.62-.73-.46-.16.15.5.1.01.24.03-.06-.33-.16-.28-.15.11.38-.29-.31-.19.11.2.19.41.04.11.26-.26,0-.36-.62-.55-.36-.2-.02-.08.34.15.19.1-.04.19.25.35.3-.14.06-.25-.16-.38-.13.2.33.15.18-.19.12-.1-.08-.17-.43-.39-.31.02.11.28.28,0,.15.06.1-.06.36.13.19.08,0-.1.09.08.08.11-.07-.02.2-.03.13-.26-.03-.04.28.13.15.08.04.34-.12.27-.2.22.1.19-.04.18.22.17.04.09-.3.27-.24-.08.14-.13.22.01.26.04-.29.14-.25.07.02.1.31.1-.25.23-.05.09.02.02-.3.17-.13.09-.06-.09-.11-.14-.13,0-.18.16.03.16-.07-.09-.33.04.1.25-.11-.07.08-.13.33.04.34.21.09-.54.14,0,.22.28.28.1-.38.39-.09.02-.32-.06-.14.23-.15-.04.15-.27.48-.17.6.47-.4-.19-.36.52-.39.18.09-.56.08-.21.28.92-.14.42-.07.8-.47.8,0-1.44.87-.4.73.32-.34.85.28.84-.15.72-.92-.48.74.47.19.01-.24.02.05.13-.18-.06.24.06.35.25.16-.06-.09-.03-.71.04-.45-.11.21.08.58.35.41.09-.49.06-.33.14-.02.19,0-.04-.51.11-.4,0,.04,0,.33.08.2.03-.12.1-.38.08-.06-.5.62,2.78,1.22,1.71.27-.49-.29.43.18.52.29.62.1-.59-.81.14-.28,1.2.36,3.39-.09,4.71.9.45-.08.72-.25,1.25-.3.11-.34.1-.22.51-.25.22-.04.07.22.23.25.08-.2.48-.07.42-.29.28-.21.2.52.43-.18.23-.31.54-1.05-.19-.75Z"
                      />
                      <path
                        class="cls-1"
                        d="m45.04,120.55c.14.26.78.52.41.04.04.09-.54-.32-.41-.04Z"
                      />
                      <path
                        class="cls-1"
                        d="m44.88,124.06c-.13.04-.06.3-.19.38.08.1.24-.08.17.13.32.09.4-.57.01-.52Z"
                      />
                      <path
                        class="cls-1"
                        d="m44.96,123.37c-.11.23.18.39.22.6,0-.2.12-.62-.22-.6Z"
                      />
                      <path
                        class="cls-1"
                        d="m40.9,170.34c0-.17-.38.11-.43.05-.05-.22-.08.03-.19-.11-.08,0,.02.12-.06.12-.64-.34-.31.06-.48.11.02-.13-.06-.15-.16-.07-.4-.25-.13-.09-.14.09-.3.17-.26-.21-.53.12-.07.14.32.14.13.29.15.26.53-.45.45-.17.24.01.34-.3.57-.26-.06.07-.04.34.06.17.21.03.74-.44.54-.04.15.05.62-.45.24-.3Z"
                      />
                      <path
                        class="cls-1"
                        d="m25.66,168.4c.07-.34-.31-.71-.26-.99.23.1.52.75.72.25-.28-.45-.29-.92-.27-1.45-.05-.54-.42.29-.58.37-.1.26.41.41.17.58-1.1-.74-.49,1.49.23,1.23Z"
                      />
                      <path
                        class="cls-1"
                        d="m25.31,163.46c-.1.07-.38.26-.09.24.14-.04.38-.39.09-.24Z"
                      />
                      <path
                        class="cls-1"
                        d="m25.96,167.92c-.53-.12-.07.35.18.27.13-.21.11-.46-.18-.27Z"
                      />
                      <path
                        class="cls-1"
                        d="m84.42,32.53s-.02.02-.04.02c.03,0,.04-.02.04-.02Z"
                      />
                      <path
                        class="cls-1"
                        d="m47.32,9.77s.04-.07.06-.11c-.03.04-.05.07-.06.11Z"
                      />
                      <path
                        class="cls-1"
                        d="m30.11,153.21c0-.12-.04-.25-.15-.37.05.14.1.26.15.37Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.35,142.99s.12.04.2.05c-.03-.04-.09-.06-.2-.05Z"
                      />
                      <path
                        class="cls-1"
                        d="m77.77,84.29c.22-.14.47-.3.74-.47-.01,0-.02,0-.05,0-.16.15-.49.29-.69.47Z"
                      />
                      <path
                        class="cls-1 top-map"
                        d="m93.5,75.91c.03-1.02,2.01-1.77,1.35-2.4.03-.09.12-.22.19.01.27-.03.23-.39.28-.58.04,0,.13-.2.01-.16,1.01-.75,1.15-1.67.95-2.91-.28-1.14,1.36-1.69,1.29-2.45-.17-1.17.28-2.38.58-3.51.21-.95-.33-2.25-.29-3.16.03-.36.51-2.02.21-1.4.12.25-.34.17-.16.41-.11-.05-.11-.18-.05-.26.49.2-.31-.54.1-.4.09-.15-.43-.3-.28-.38.18-.03.17.3.35.28-.04-.09,0-.45-.03-.63-.02-.04-.04-.07-.05-.11-.03-.02-.08,0-.15.09.02.23-.1.14-.01-.06.14-.23-.06-.45.28-.3-.05-.19.11-.43.33-.49-.44-.25.18-.2.2-.61-.17-.05-.58-.15-.31-.5-.09.72.37.33.39-.18.04.18.18.31.39.33.09.09.11.31.11.47-.08-.12-.07.1-.14.15,1.15-.29,2.84-3.05,2.54-3.55-.02-.01-.04-.03-.09-.07.04.01.07.04.09.07.07.05-.01-.05.16-.21.09-.07.1-.08.04-.25.09.07.07.2.1.02.02.04.09.13.02.13-.18.09-.37.52-.06.33-.03-.28.65-.56.23-.66.04-.04.03-.05-.06-.08-.19-.13.1-.13.16.03.35-.04.86-1.25,1.73-1.26.3-.62,1.47-1.3,1.26-1.76,0-.01-.01-.02-.02-.03-.04-.06-.1-.12-.19-.17.11-.06.15.07.19.17,0,.01.01.02.02.03.01.03.03.05.04.06.1-.07.2-.18.09-.29.7.44,1.97-2.33,2.14-3.28-.03.07-.04-.03-.05-.06-.03-.05-.1-.08,0-.04.16.16.12-.09.18-.2.13-.24-.29-.23-.12-.47.08-.11-.11.04-.06-.04.04-.04.08,0,.09-.07,0-.03-.08-.2-.02-.12.08.21.04-.09.09.11.13-.16-.05-.32-.23-.27.4.05.34-.68.24-.91,0-.41-.02-.32-.16-.04-.11.05.14-.29.08-.44-.36-.37-.14-1.14-.48-1.49-.04-.09-.1-.06-.15,0-.11-.02.06-.09.03-.13.13.16.02-.18.05-.21-.23-2.85-2.42-1.89-3.88-2.19-.15-.28-.42-.25-.71-.28-.36.05-.37-.56-.75-.56-.94-.29-1.82-1.45-2.45-2.02-1.77-.73-3.23-2.5-5.33-1.83-.13-.04-.47.05-.65,0,.1.1,0,.08-.08.02-.08-.05-.43-.02-.38.05.07-.03.22.24.11.21-.05-.11-.21-.05-.17-.16-.04-.02-.29-.12-.24,0-.02.02-.06.02-.03-.01.02-.17-.3.04-.41-.07-.06-.07-.13,0-.17-.07.23.02-.18-.13-.25-.25.05.02-.39-.11-.47,0,.14,0,.26.23.11.2-.18-.1-.36,0-.54-.07-.05.03-.09.13-.07.01-.01,0-.11.05-.05,0,0-.16-.36-.11-.49-.14-.05-.1-2.76-1.49-2.17-.54-.06,0-.14.02-.06.1,0,.08-.04.02-.05-.03-.09.16-.02-.06-.13-.06.03-.07-.03-.16-.08-.07.09,0,0,.18.02.06-.02.01-.06.09,0,.07.04.05-.1.01-.11,0-.06.05-.08-.09-.16,0,.02-.05.07-.09,0-.06-.09.05.07.2-.06.12-.09.12.01-.06-.07-.13-.01.19-.42.09-.34.31,0,.07-.08-.13-.1-.16-.05,0-.12.12-.06.15-.04-.03-.2.02-.2.12-.08.07-.08.4-.08.19-.01.04-.03.02-.02-.01,0-.04-.07.05-.06,0-.02-.06-.07.13-.11.16-.03-.05-.1.12-.12.05-.09-.04.13-.08.03-.17.05-.09-.14,0-.07.03-.1-.1-.13.01-.17.09,0-.01-.05-.04-.02-.05.03-.07-.02-.06-.05-.03,0,.02-.02.04-.01.06-.01-.02,0-.05.01-.06.04-.13.34-.28.33-.23.14,0,.15-.19.16-.23.08-.06.2-.07.17-.2.04,0-.32-.16.01-.11-.07-.18-.52.05-.62.14,0,.05.04.09.03.15-.09-.27-.22,0-.17.13.01-.01.02,0,.03.04-.01-.01-.02-.03-.03-.04-.04.04-.12.3-.07.32,0,.56-.75.67-.85,1.1-.12,0,.04-.06-.06-.16.07-.21.58-.34.21-.51-.1-.32.7-1.25.09-.86.16-.09.47-.24.3-.44-.03,0-.21.15-.03-.02.49.19.47-.23.18-.51-.17.02-.3.22-.42.31-.04.06,0,.3-.05.28.06-.19-.09-.08-.13-.04.05-.08.23-.39.05-.22-.52-.11,0,0,.19-.24.2-.09-.2-.08.02-.08.18-.16.35-.32.02-.23-.08-.03.01-.01.05-.05.05-.06.15.03.19-.06.02-.15-.15-.26-.2-.23.06-.03.18-.08.08-.13-.04.07-.1.12-.05-.02-.15.07-.3.03-.08-.16-.21-.17-.07.22-.27.13,0-.08-.17.04-.21.02.13-.11.33-.16.08-.23.06.07-.08.16-.11.1.21-.02-.01-.19.07-.29-.06-.02-.02-.01-.1-.11-.05.06.02.15-.02.16-.12-.13-.1-.04-.16,0,0,0-.01.02-.04.02.02,0,.03-.02.04-.02,0-.03-.06-.06-.08-.09.14.03.04-.09.13-.16.03-.08.15-.09.1-.2-.15,0-.22.13-.27.31-.03.04-.21.03,0-.07-.03-.03-.21-.05-.07-.05.03-.13-.22-.04-.15-.2.01.07-.13.18-.04.09-.16.02-.15.05-.28.12-.2.15.03.44-.27.47-.24-.06.11-.37-.14-.42-.02.04-.04.06,0,0,0,0,0,0,0,0,.04-.07.1-.21-.02-.14.2-.1.31-.25.1-.37-.02.08-.19.42-.16.26-.12,0-.05.12-.07.2-.05.07-.02-.14-.14-.05.07-.04-.02-.12-.03-.04-.06.04-.03,0,0-.04.04-.03.1.03.07-.04.01-.05.03-.13.04-.17.1,0,.18-.1.11-.16-.15.01-.3.57-.23.04,0,.03-.07.14-.06.05,0-.02.07-.07.04-.06-.11.02.06-.07-.02-.08-.09.11-.13.12-.09,0-.12-.07-.07.37-.2.17.09-.09,0-.18-.01-.27-.02-.12-.08.02-.14.05,0-.06.18-.27.03-.25-.05.16-.2.35-.23.39-.08-.08.03-.11-.01-.21-.04-.09-.02.07-.04.08-.1.08-.07.05-.04-.06-.18.12.02-.01-.05-.1.04-.05-.02-.04-.03,0-.12.12.21-.25.07-.26-.17.17-.11.57-.31.28.04-.19.13-.07.05-.3-.03.11-.17.13-.12.28-.05.16,0-.14-.08.01-.17.12.07-.16-.05-.19-.06-.25-.19.41-.12.05,0-.08-.07.03-.07.05-.08,0-.17-.02-.22.07.09-.13.14-.35.11-.4.11-.09.13-.21-.04-.17-.11.05-.06.2-.11.23.01.04.06.11.08.15-.02-.05-.14-.2-.11-.08-.12.3.04-.2-.11-.05,0,.13-.07.05-.04-.05-.28.21-.38-.14-.12-.27-.26-.05-.43.25-.7.22-.19.16.08-.1.14-.13,0,.08.12.04.12-.02-.05-.01.08-.23-.11-.23.01.04.08.2,0,.12-.1-.16-.08.13-.21.19.09-.09.09-.19-.01-.27.02.05-.04.15-.05.06,0,.17-.09.07-.03-.09-.05.05-.08.08-.09-.01.07-.04.08-.11.05-.18-.03-.05-.13.12-.12.14.09.01-.03.11-.03.03-.08-.09,0,.14-.05.09.02.08-.16,0-.11.1.02.07-.08,0-.03-.04.03-.04.12-.05.07-.09-.02,0-.02-.05-.03-.09-.01-.03-.04-.02-.04,0-.05.02.05-.15.01-.16-.06-.07-.02.07-.08.1-.14,0-.1.29-.19.17.11-.15-.06-.15,0-.35-.1-.13-.09.25-.12.12-.07.02.02.16-.04.12-.01-.09-.09-.01-.12-.05.25-.22-.03-.07-.12-.13.02-.01.07-.11.09-.04.1-.04-.05-.1-.08-.13.07.18-.1.07-.08-.05-.1-.02-.17.04-.1.12-.03-.03-.1-.08-.13-.02,0,.04.06.11-.01.06,0-.08-.07-.04-.05.02-.05-.09.07-.25-.09-.21-.11.14-.05.27.07.33.2.22-.04.03-.19.06.04-.13-.09-.29-.18-.39-.25.62-.27.26-.54-.04-.02.25-.09.26-.31.38-.09.23-.15-.12-.21-.17-.45.16-.05.83-.58.82-.02.09.03.19.16.15-.16.07-.19.15-.26.43-.1-.02-.3,0-.2-.17-.25.07-.27.71.2.51,0,.09-.2.12-.3.11-.1-.1.22.42.05.25-.26-.05-.32-.39-.49-.54-.26.34-.5.84-.86.98.21-.17.28-.41.38-.6-.32.15-.54.38-.68.68-.38.23-.84,2.17-1.1,1.6.38-.31.28-.97.6-1.35-.06,0,0-.04.01-.07.11-.19-.35-.13-.12-.34.06-.14-.14.13-.07-.04-.08-.13-.2.13-.18.18-.07-.14-.35.08-.22.1.09.04.16.34.07.13-.21-.18-.25-.14-.47-.14-.02.02-.08.19-.05.04-.05-.13-.01.17-.02.19-.02.06.11.23.03.2-.06-.13-.09-.09-.14-.02.33-.38-.32-.83-.63-.37-.4-.34-.69.76-.64.04-.04.02-.14.16-.05.02,0-.09-.19-.01-.23-.12-.23-.53-.53.53-.75-.02.01-.09.08-.02.13,0,.15.11.38-.2.23-.31.32.2.14-.31-.04-.39-.27-.33,0-.74-.47-.92.24,0,.35-.25.3-.44-.06-.04-.4-.06-.25.06-.03.05-.12-.13-.17-.03-.38.71-1.48.99-2.36,1.44-.2-.04-.54.34-.49.08.2-.41-.7-.16-1.01-.1-.17-.14.38-.16.49-.24.17-.11.57-.42.74-.22.45.19.52-.18.56-.48.11-.02.18-.06.24-.1.05-.1.11-.2.17-.3.03-.15.03-.32.07-.49.21-.23.44-.44.27-.46.31.07.42-.38.56-.58.03-.2.32-.26.05-.37-.07-.05.09-.01.12-.02.9-.3,1.47-1.01,2.06-1.72.25-.65,1.94-1.03.5-1.09,1.36-.05.35-1.63-.65-1.25-.32-.02-.35-1.04-.71-.61-.08.25-.03-.16-.11-.16.7.33-.56-1.72-.51-1.96-.24-.43-.08-2.61-.37-1.24.34-1.22-1.45-2.6-.6-.61-.11-.19-.21-.48-.31-.66-.08.13-.13.52-.43.5-.5.74-1.14,1.49-1.51,2.28-.26.54-.67,1.8-1.55,1.57-.75.06-.06-.03-.59-.28-.24.33-.82.16-.95-.06-.26.13-.35.29-.62.41-.15-.11-.11.22-.26.14-.27-.21-.88-.08-.96-.43-.22-.03.56-.28.56-.63.42-.45.3-.89.33-1.28.27-.29.65-.78.24-1.02-.56-.67-.91-1.19-.83-2.1-.58-.99,1.31-1.61.92-2.57-.53-.24-3.51-.47-1.99-.09.08,0,.12.12.03.03-.14.06-.3.04-.45-.02-.02.03-.01.09-.04.11-.15.06.05-.05-.02-.11-.08-.1-.2,0-.3-.06-.41-.17-1.19-.32-1.58-.02-.11.1.22.39.08.52-.33-.49-2.02-.9-2.69-.57-.24.53-.34,1.57-.23.35.31-.35-.37-1.55-.82-1.05-.61-1.26-2.3-1.9-2.53-.33-.17,0,.43-1.49.39-1.93-.68-.93-1.61-1.69-2.84-2.31-.49-.05.54.27.62.53-.73-.3-1.65-1.57-2.4-.87-.51-.17-1.21-.25-1.36.28-.17-.09.22-.2.05-.21-.23-.03-.4.07-.54.23-.22-.29-.57-.2-.86-.43.24-.24,1.13.36,1.1-.3.03-.06.12-.22.21-.39,0-.03.02-.07.06-.11.18-.34.32-.66-.02-.24-.15.18-.03-.11.06-.16.21-.19.7-.27.57-.52-.35-.29-.47-.43-.94-.48.04.1-.95-.9-.49-.29-.13-.16-.34-.34-.56-.36-.02.08.49.32,0,.22-.17-.13-.56-.03-.23.08.12.38.11.35-.08,0,0,.08-.11.28-.1.19.18-.37-.5-.73-.84-.75-.2.19.35.18.41.31-.13,0-.49-.27-.32,0,.02.16.06.34-.04.49.02-.09-.05-1.17-.2-.26-.18.34-.1-.33-.39-.36.05-.22-.12-.64-.41-.64-.03.11.1.32-.1.36-.17.05-.3-.09-.28.13-.08,0-.03-.07-.13-.1-.05-.06-.2.09-.16-.06-.1-.06,0,.27-.08.1,0-.05-.02-.19-.07-.09-.06,0-.13-.1-.03-.05.13-.02.18-.02.25.07.08-.07.1.04.15.05.08-.25.64.14.35-.32.04-.26-.2-.43-.41-.45h0s-.03,0-.06,0c-.08,0-.14.02-.19.06.06.09.1.26-.12.21.06-.1.11-.15.06-.27-.16-.04.11-.02.24,0,.02,0,.04,0,.06,0,.08-.11,0-.39-.19-.25-.05.05-.31.21-.1.06.42-.41,1.34.13,1.64-.33.31-.06.76.09.9-.22-.95.13-2.74-.12-3.54.15-.27,0-.63.19-.91-.06-.05-.13-.05.04-.08.06-.33.16-.82-.02-1.05.05.05.15.1.39.31.14.3-.05.47.04.76.05.96.49-1.05-.13-1.19.4-.04.09-.07.02-.07-.04-.1-.05,0,.23-.21.11-.03.11.21,0,.2.07-.13.04-.22.16-.36.1-.61,0-.25.44-.82.36-.16-.13-.62.29-.61.02.23.09.14.01-.03-.04-4.03-.75.14-1.68-6.47-.85-.61.18-1.05-.95-.6-.83.08-.11-.23-.1-.29-.12.29-.11.23.07.06-.33-.53-.85-2.02-1.01-3.02-.93-.43-.66-.47-2.22-1.37-1.08-.22.5.25.39.07.8.26.11.6-.12.87-.14.14,0,.2.31.23.47-.14.17-.24.08-.4-.04-.13-.06-.38-.05-.55-.16.14.06.08.08.15.11.26.04.08.33-.1.11-.07,0-.03.02,0,.05-.57.46-2.79.81-3,1.26.14.26-.14.07-.3.14.19.71.58,1.45,1.17,2.11,0,.3.13.92-.1,1.19-.29.33-1.39.97-1.46.2.13-.11-.28,0-.06-.14.16-.03.06-.18.1-.25-.09.12-.15-.08-.23-.09,0,.01-.15-.02-.14.02-.02.03-.02.13-.04.01,0-.09.18-.05.14-.08-.12-.02-.14-.17-.24-.09-.05.02-.09.12-.12.02-.08-.19.11.08.12-.08,0-.07-.05-.09-.11-.13.06-.1.06-.04.1.05.12.04-.25-.49-.32-.48-.04-.78,1.43-1.34,1.11-2.12-.18-.07-.48-.88-.13-.57.35.11-.42-.39-.42-.47-.83-1.26.52-.79,1.19-1.26-.12-.37.78-.41.42-.79-.07-.4-.9-.83-1.25-.64,0,0,.02,0,.02.01.07-.03.06,0,.02.04.05,0,.16-.03.06.02-.1,0-.12.2-.14,0-.04,0-.13.05-.06.06,0,.14-.38.2-.16.03-.14-.06-.21.18-.35.2.07-.03.31.09.19.17-.17-.04-.12.27-.31.03.05-.06.17-.14.02-.15-.58-.07-.15.33-.48.63-.16.42-.76.38-1.13.56-1.61,1.19-1.68,1.01-3.32.88-.21.06-.25.31-.15.48-.16.23-.24.81-.57.74,0-.08-.05-.22-.09-.16-.11.07.13.23-.09.16.02-.07-.03-.1-.05-.15-.04,0-.03.16-.09.09,0-.06-.01-.18.05-.22.18.02.27.14.15-.08,0-.19.23-.07.36-.1.28-.03-.85-.06-1-.26-.17-.06-.27.23-.52.25-.02.28-.44.24-.58.43.04.09.19.03.06.16-.05-.18-.2.09-.35.06-.08.13-.35.25-.21.38.04.05.02.21-.07.16.05-.13.03-.11-.06-.02-.08,0-.07.18-.02.05.03,0,.02.06.04.07.03-.04.04.01.04.04.1.22-.25.09-.16.22,0,.01-.45.42-.12.25.48-.44.03.71-.14,1.01.43-.19.34.8-.08.58-.5.14.08-.11-.32,0-.15-.05-.15.02-.23.1-.18.05-.31.13-.36.27-.23.54-.74.87-1.19,1.22-.17.12-.52.07-.63.27-.02.1.35.19.37.38-.1.42.37.99-.19,1.05-.18,0-.19-.15-.16-.25.04-.09.26.03.17-.04-.06-.03-.01-.05.02-.02.01-.02,0-.03-.03-.04-.08-.02.08-.04.06-.06-.04.03-.06,0-.04-.03.08-.08-.08-.02-.11-.04,0,.11-.17,0-.12-.06.02,0,.05.02.04-.02.07-.12-.12.03-.1-.16.09-.03-.07-.02-.14-.03-.12-.25-.56-.48-.63-.71-.07-.03-.08-.17-.14-.19,0,.11-.2.06-.14.19-.33.26.16.28.11.58.12.2.58.71.41.85-.52.1-.26.76-.91.89-.08-.13-.16-.45-.37-.39-.09.13.27.6-.13.5-.04.21-.29.52-.03.65.26.27.27.08.41.43-.4.25.4.28.26.68.24-.3.24.06.42.18-.05.18.02.99-.28.61-.17.51.88.92.39,1.38-.02.21-.23-.02-.33.13-.09,0-.31.22-.19.23.11-.03.3.01.32.16.07.07-.07.01-.02.09.1.04.13.25.1.34-.1.42.04.82.22,1.1-.1-.19-.18-.04-.06.05,0,.07-.05.05-.06,0,.06.11-.11.43.01.44-.25.12-.14.62.17.46-.09.23-.26.02-.38.16-.15.1-.04.29-.05.41.12.08.21.31.24,0-.04-.14.16-.1.13-.22.06.05.1.07.17.09-.01.06-.21.25-.05.18.02.05-.22.04-.12.02-.27-.02-.03.52.39.14,0,0,0,0,.03-.02,0,0-.02.01-.03.02.02,0,.13-.02.14-.02,0,.11-.19.11-.18.19.04.04-.03.09-.02.05-.12-.09,0,.09-.06.11-.02.01-.09-.01-.06.02.16,0,.04.09-.06-.02-.11.25.31,0,.06.14-.05.07.07,0,.11.04-.12.03-.17.06-.24.17,0,.05.04.05-.04.06,0-.02-.12-.07-.1,0,0,.02-.07.03,0,.05.02.02-.07-.01-.09,0-.05.07.14-.02.1.06-.07-.03-.04.03.01.03-.04.01-.02.02,0,.04.04.07-.05-.03-.09.02-.06-.15-.03.03-.08.1,0,.01.05.05.02.06-.15-.12,0,.18.04.19-.25-.26-.32,0-.51.16.01,0,.24.04.09.05-.1.15-.78.64-.29.5-.02.04.04.28-.11.15-.08-.08-.12.08-.08.13.07-.09.25.04.12,0-.16.02-.18.08-.07.15-.05-.04-.17-.08-.22,0,.05.03.21,0,.04.05-.14.03-.06.07-.07.16.08.04-.04.04.07.09.18.18-.28.28-.31.13.07-.11-.05-.06-.1-.16-.11,0-.22.08-.34.05-.04.07.07.19.03.28-.15.18-.37-.09-.35-.26-.34.58.12-.48-.69.37-.06.14-.52.58-.3,1.06.06.06.07-.18.16-.08.06.06-.02.16,0,.24.03.11.14-.1.11.02-.04.03.03.1-.01.14-.07.22-.35-.02-.56,0-.33.08-.71.59-.19.6.12.08.19.35,0,.48,0,.13.29.08.02.09-.04.15-.15.06-.19.18-.07.34-.03.06-.24-.02-.28.48-1.2.16-1.36.67.16.25-.11-.05-.02-.21-.27.33-1.23.2-1,.76.16.01.21.22.11.32-.05.13.29.47,0,.34.31.95-1.83,1.49-.6,2.16-.96-.31.01.74-1.19.61-.54.38.28.66.11,1.11-.53.3.79,1.76-.55,1.55.2.36.69.4.99.66.15.17.58.6.76.44-.21-.31-.01-.07.08-.21.34-.02.22-.64.53-.6.17-.16-.35.42-.06.29.14-.02.23.17.06.04-.57.42.56.3.26-.39-.06-.16-.18-.43.06-.49.09-.22.21-.1.04.02-.32.36.18.77.19,1.14-.45.78-.35,1.46-1.17,1.57-.27-.13-.07.35-.65.34-.67.79-2.46,1.77-1.59,2.81.65.72.21.32.11.82.01.2,1.48,1.48.31,1.37-.08-.16-.09.06-.19.05-.52.9,3.74,1.77,3.79,4.06.6.79,1.61,1.37,1.61,2.28.18.24.28.42.3.67.14-.05.29.3.05.2.02.05.11.19.13.14-.11-.19.21-.13.14,0-.05.07-.09.07-.04.16.04.06.2.06.2.14-.06.13.12.21.07.35.21.43.44.79.5,1.24.21.73,1.47,1.73,1.23,2.44.01.43,1.3.76,1.05,1.29-.04.15.2.37.06.52-.16.11.43.11.25.31.11.19.84.35.54.66.27.33.65.69.7,1.12.72.7,1.02,1.72.26,1.97,0,.17.21,0,.23.06.1.19-.03.43.05.65.07-.3.5.26.29.28.03.16.46.22.38.42.37.64,1.2.99,1.7,1.55.14.61,1.66,1.13,2.46,1.53,1.29,1.17,3.53,1.25,4.68,2.48.64.38,2.02.59,1.7,1.55.9.35,1.72,1.06,2.48,1.69-.38,1.3.54,2.6.36,3.82.02.48-.18.88-.11,1.37.05.49.19,1.04.31,1.64-.06.22-.12.44-.17.66h66.77c-.05-.27-.07-.57.15-.92Z"
                      />

                      <path
                        class="cls-1 bottom-map"
                        fill="url(#bottom-to-top)"
                        d="m26.58,76.83c-.21.87-.34,1.77-.36,2.67-.17.9-.6.18-.65.5.1.33-.32,1.02.03,1.04.9-.75-.56,2.84.21,3.48-.21.38.22.22.03.86-.29.21-.5.53-.54.9-.2.33-.07.08-.01.34.36.3-.14.85.15,1.09-.08.01-.06.13-.14.1.03.58-.3,1.06-.29,1.6-.47.24-.3.56-.18,1.1-.03.45-.4.33-.45.8-.31.42.04,1.26-.41,1.58.11.55-.75.85-.51,1.4.03.89.57.35.39,1.86.26.27-.08.31-.15.46-.14-.05.2.65-.14.44-1.17.72-.32,2.75-.17,4.13.04.39-.12.93.12,1.33.22.07.07.34,0,.47-.02.16.2.43-.08.5-.05.23-.04.47-.15.77-.45.1-.42.36-.24.75.37,1.03-.92,1.64-.72,2.73-.31,1.12-.6,2.34-1.51,3.18.37.62-.27.82-.4,1.37-.02.37-.04,1.1-.39,1.2,0,.17.14.45-.11.51-.65-1.01.28,2.06-1.17,1.26-.43-.39-.15.85-.13.88-.62.58.83,1.32.19,2.03-.27,1.59,1.31,2.24.37,3.85-.17.14,0,.53-.08.73-.07-.45-.38.09-.67.09-.17.15.12.26.05.47-.08.07-.2.16-.15.3-.14.71-.07,1.2-.39,1.84-.07.4-.07,2.78.89,1.91-.17.36-.53.18-.53.65.54.1,1.21.25,1.54-.2-.03-.15-.21-.37.06-.37-.01-.02,0-.12.03-.12.15.06.14-.22.29-.02.45-.17.4.82.83.51.51.01.35-.68.49-.92.11.22-.09.53-.02.77-.16.24-1,.24-1.17.72-.23.12.19.44.37.35.09,0,.18.16.27.02,0-.11.18-.29.22-.08-.08.32-.05.52,0,.72.16,0,.06.04-.03.1-.05.19.17.28.12.5-.2.27-.18-1.12-.58-.67-.71-.02-.06.86.26.92.11.31-.44-.26-.61-.06-.08.13-.16.32-.01.43-.27.46.24.61.17,1.12.12.32-.15-.13-.25-.05-.25.43.02.61-.5.88-.1.42,0,.77.41.87-.22.07-.44.35-.17.46.32.12.31-.56.31.04.04.05.07.14-.03.1-.05-.3-.3.22-.32-.07-.11-.05-.14.45-.29.5-.15.1.12.46-.07.41-.02-.06-.08-.13-.14-.06-.03.02,0,.24-.04.16-.14-.12-.16.12-.08.2.14.1.26-.05.32-.13.12.15-.14.2-.14.29.41.08.55.29.81.5.07.13.27.05.24.26.2.03.17-.34.32-.44,0,.24-.16.56-.25.86-.07.56-.96.99-1.56,1.03-.22.38.62.54-.15.69-.13.44.3.22.54.18.23.24.54.51.85.42.12.28-.35.23-.46.06-.28-.07-.57-.69-.64-.06-.18-.25-.17.1-.21.17-.21-.6-.58,1.45-.27.89.31-.52,1.3-.23.3-.12-.29.33-.72.75-.5,1.18.04.3-.21.43-.16.74.08-.08.25-.21.18-.32.09-.11.77-.95.48-.49-.11.14-.63.78-.19.75-.84,0-.45,1.21-1.14.83.07-.29.53-.58.51-.92-.04-.2-.35-.57-.54-.33-.1.19.22.34.35.54-.18.05-.22-.22-.42-.17-.19.22-.03-.02-.03-.12-.1-.02-.04-.1-.01-.15-.25.18-.99.25-1-.09.21.56,1.57-.1,1.03-.5-.16-.24.05.39-.31.4.17-.09.31-.48,0-.41.13.04.36-.2.2-.26-.02,0-.22.05-.13-.01.11-.07-.07-.11-.13-.11.21.03.25-.31,0-.27-.35.15-.26.02-.47.02-.42.06.18.41-.16.69-.1-.06.11-.22,0-.3-.11.04-.07-.09-.18-.07-.07.03.1-.41-.12-.19-.22-.22-.25.13-.3.31.07.07-.09.28.04.24-.06.03-.45.31-.14.45.07.05-.09.06-.01.15-.21-.3-.5-.17-.35.19-.15,0-.16-.25-.33-.2-.13.08-.25.42.03.4.12.2-.44-.26-.34-.03-.03,0-.03.21-.04.23,0-.32-.56.12-.35.21-.5.17-1.19.73-.51,1.34.07.5.95-.27.37-.11.03-.05.21-.25.08-.27-.06,0-.26.01-.11-.06.15-.29-.3-.22-.42.09-.12-.18.24-.37.45-.43.05-.13.18.12.23-.02.29-.06.53-.07.66-.41.11.1.17-.15.2-.19.11-.15.05.16.05.2-.56.33-.19.68.2.93.05-.06.07-.23.12-.07.17.24.35.24.59.33.14.12.39-.24.12-.1-.05,0-.08-.09-.13-.09-.04,0-.41.1-.22-.02.02-.05-.04-.16.05-.16.19.2.37.01.28-.09-.08-.02-.15-.03-.2-.05.11,0,.17.02.2.05.17.03.39.06.5.1.16-.02-.07.15.05.16.06.25.17,0,.32,0-.49.45.17.39.42.63.04.12-.46.46-.13.43.07,0,.08.44.03.22-.03-.03-.06-.32-.14-.14-.33-.08-.17.31-.15.44-.16-.02-.05-.47-.26-.38,0,.23-.03-.03-.11.02-.01.02-.66.56-.53.81.13-.15.08-.15.26-.07.07.08-.13.05-.14.11.03.1.16.23.25.12,0,.15.08.34.25.2.11.07.39-.18.38-.1-.02.07-.19.08-.14.14.03.08.23.02.17.09-.26,0-.79,0-.18.13-.42,0-.49.16-.06.26-.37.17-.34-.48-.74-.15.06-.08.5-.27.2-.34-.06.21-.02-.28-.2-.12-.04.05-.01.12-.09.15-.01-.43-.44.1-.07.19-.03.07-.12.13-.07.02-.08-.14-.25-.07-.33.08-.03.16.21.23.34.24.09.1.3-.12.46-.09.16,0,.03.08-.07.07.22.18.7-.1.83.11.42.4.65-.2.72-.57-.16-.05-.05-.23.02-.31-.08.17.22.02.04.21.19.23-.1.19-.07.48.03.24.28.11.42.21-.36.19.1.25.09.32-.12.36.6.01.65.31-.2-.05-.41-.08-.64-.08-.11-.07-.43-.58-.29-.06.02.21.3.5.53.65.21.06.25-.31.27-.27.03.33-.16.5-.43.3-.57.5.09-.06-.62-.28-.05-.04-.09.09-.12.1-.07-.07.11-.15.08-.24-.03-.18-.25.29-.28.15.11-.15-.01-.28-.18-.12-.1-.11-.73-.3-.84-.11.16.18.17.43.29.57.12.23-.15.06-.19-.07,0-.34-.23-.68-.58-.67-.12.12-.33.16-.16.36.18.04.48-.34.22.05.08.31.39.36.54.57-.02.45.19-.05.44.16-.55.1-.25.1.06.24.03.16.47-.07.32.09-.47-.01-.12.43-.18.58-.16-.05-.29-.44-.51-.38-.22.11-.61.69-.23.6.03.07.09.08-.01.13-.02.15.25,0,.35,0,.56.18-.08,0-.24.12-.05.05-.19-.03-.14.04-.04,0-.07-.18-.11-.09-.15.25-.24.5.04.67-.21-.04-.07.06-.09.18-.07.12-.19.08-.14.26.02.19.15-.12.14.07,0,.52-.15,1.02.37,1.45.19-.25.28-.75.11-1.06.08-.1.11.11.2.04.23-.19.1-.47.11-.69.14.13.45-.18.54.1-.1.18-.21-.23-.36-.02-.23.16-.06.17-.03.38,0,.19-.09.42.15.56,0,0,.21.07.18.09-.52.01-.46-.73-.63.17-.03.57.25.18.55.42-.19.41.68.59.33.81.03-.27-.37-.25-.41-.48-.09-.28-.09-.39-.28-.07,0-.69-1.25.45-.38.41,1.04-.14-1.23.29.03.57.15.21.44.3.48.02.17.1.18-.41.18.04.08.04-.29.05-.24.25.12.19.33-.07.28.29-.08-.01-.05-.19-.16-.17-.16.08-.29-.04-.38-.07-.15.12-.21-.46-.44-.19,0-.04-.03-.11-.08-.05-.1.15.06.46.25.49.04.17.08.49.33.38.3.06.09.03.28.2.08.05.43.07.16.15-.24.02-.45-.49-.66-.13-.04-.1-.1-.4-.3-.29.16-.16-.08-.41-.31-.25-.06-.1-.15-.03-.08.09-.07.09-.09-.03-.1-.08-.29-.07-.53.52-.14.31-.16.39.29-.1.11.21.03.05.09,0,.12-.02.06.03-.2.21,0,.26.12,0,.05.13.23.14.2,0,.09-.36.25-.34.14.2-.21.36-.01.55.1.11.09-.06.17-.07.16.06.26-.09.33-.17.24.08-.33.22-.01.39.14-.1.14-.05.13.11.61.23,0,.11-.21-.05-.18-.09-.02.11-.09.16.13.21.02.19-.03.02-.06-.48-.56-.22-.09.06-.02.09-.12.13-.05.23.09.06.2.56.24.25-.03-.11.09.03.13.04.04.1-.1.1-.15.17.4.62.84-.16.75-.55.08-.37.87-.93.32-.3-.41.1.23.51.4.5.07.08-.03,0-.08.06-.04.04,0,.11-.08.1-.29-.54-.71.09-.45.42-.11.03-.23-.26-.27-.02-.04.09.29.3.15.47-.24-.14-.1-.43-.44-.26-.35-.1-.64,0-.56.36-.06.5.43-.28.35-.05-.09.23-.29.69.08.82.2-.03-.05-.34.1-.32.07.16.14.45.35.38.1-.12.27-.22.2-.38.04.11.11.05.17.07-.1.09-.06.19.05.19-.1-.01.03.4-.06.26.03-.2-.33-.36-.11-.06.12.15,0,.78.34.62.03.08-.09.09-.13.12-.09.2.23.08.04.24.27.86-.39-.99-.68-.45.04.14.04.28.06.42.03.06.25,0,.19.07-.04.09-.2.14-.18.25.11.16.67-.06.22.18-.06.07.07.11.1.16-.01.05.12.36.19.19-.04-.08.04-.18.05-.26.07-.1.09.17.18.07.06-.12.07-.15.07.03.05-.06.12-.12.21-.12-.05.14-.17.15-.29.22.09.16.18.28.22.44.09.32.35.71-.05.22-.02-.16-.18-.48-.31-.39-.03.07.23.4.11.37-.03.29.27.49.46.68.05.05.14.08.19.13.18-.5-.06-1.15-.16-1.73.38-.05-.02,1.58.48,1.43-.15-.59,1.22-1.13-.03-.68-.13-.06.2-.16.25-.12.13-.05.11-.46-.08-.27-.13-.09.12-.15.2,0,.22.03-.21-.29-.39-.2-.13-.04-.04-.16-.09-.25-.11-.03-.17-.22-.01-.12.02.11.21.05.13.2,0,.22.29,0,.34.14.1.02.14.08.11.18.04.07.17-.06.19.01.01.12.12-.09.17,0,.1.4.76.18.61-.15-.5-.03-.83-1.07-1.23-.42-.06-.08.33-.42-.02-.36-.08-.07-.18-.02-.28.02-.29-.11.16-.21.24-.24.13-.13.08,0,.13.13.43.23,1.48.6,1.28,1.25-.02.17.25.26.01.4-.06.03-.11-.02-.16-.04-.03.04-.05.18-.11.08-.46.21.94,1.01.02,1.48-.2.12.2.11.24.17-.12.23-.24-.2-.43-.09-.18,0-.34.15-.52.16-.03-.07.38-.18.32-.31.18.18.18-.3.36-.07.35-.33.14-.78-.16-.98-.03-.19.02-.37-.25-.45-.23-.01-.15.33-.23.44-.33-.17.11.95.14.15.38-.55.02.45-.05.53-.17,0-.13-.28-.35-.24-.18.29-.17.04-.07-.11.14.04.25-.29.06-.32-.21.06-.24.23-.42.15-.04.17-.04.43-.3.39-.1-.1-.57-.52-.31-.17-.18.21-.2-.1-.31-.09-.13,0-.11-.53-.31-.4-.08.21.2.41.23.58.29.04-.1.35.16.45-.02.24-.16.13-.23.27-.01.23.27.12.34.07-.13.18.2.21-.12.21,0,.07-.12.11-.11.16.04.03.18.01.14.1-.15.01-.37.14-.27.33.42-.03.09,0-.06.22-.01.1.15.07.19.16,0-.11.12-.25.25-.24-.02-.09.04-.09.12-.06,0-.06.03-.15.11-.09.17-.03-.1-.33.06-.31.05.24.28.05.1.35.19.22.51-.31.32-.52-.18-.03.03-.06,0-.16-.03-.25.05.11.12.12.17-.05.4-.07.57.05.1.21-.31-.13-.45-.04-.14.14.06.21.19.2.02.14-.18-.08-.26,0,0,.26-.21.32-.27.5-.03.14-.2.04-.16.18.02.12.24.04.18.17-.12-.02-.24,0-.35.05-.05-.21-.1.02-.19.02.07-.1-.07-.16-.17-.11-.15.24.45.1.43.38.04.03.11-.1.11-.01-.01.13.16.01.2.02,0,.02-.02.22-.11.14,0,.04.09.14.02.11-.1-.15-.34,0-.22.14-.07,0-.15-.11-.24-.03.1.1.44.52.63.38-.13-.06,0-.37.05-.2-.24.45.65.04.48-.21-.12-.23-.11-.37-.04-.49,0-.02.01-.03.04-.05.12-.15.35-.27.55-.47.14-.14.09-.26-.14-.24-.2-.47-.36.53-.49.28.26-.17.23-.89.44-.58.22,0,.34-.14.52.06.14-.24.72-.18.14-.02-.21.17.09.25.2.37.02,0,.04-.11.05-.12-.04-.04-.11.02-.05-.04.24-.73,3.68.16,1.3.31-.48-.31-1.14-.03-1.33.58-.11,0-.04-.17-.14-.19-.08-.03-.23.23-.24.07.14-.16-.08-.07-.18.06-.36.26.46-.46-.05-.47-.13.15-.31.35-.56.39-.02,0-.03.02-.04.02-.01.02-.03.03-.04.05,0,.05.08.1.1.17-.07.1-.04.67.1.47.06.14-.23.26-.08.37.07.09.21.14.25,0,.09.03.22-.1.22.02.34.24-.31-.15-.05.22-.39-.2.19.26.03.27-.04.03.02.06,0,.1-.12.04-.15-.05-.09-.17-.29-.11-.54-.48-.89-.2-.82-.35.24.6.61.64-.02.04-.01.07.04.07.18.03.16.31.21,0,.08.29.29.34.52.54,0,.02.51.06.36-.05-.12-.1-.2-.65-.41-.38-.04-.06-.11-.17-.18-.21-.09-.43.08.24.26.03.14-.1-.15-.55.13-.3.4-.15-.32-.19-.11-.32.03.06.17.19.18.08-.29-.32.21.19.27-.04-.24-.19.08-.06.21,0,.22-.07-.08-.31-.22-.27-.05-.3-.16-.1-.35-.22-.49.1.3-.21.47,0-.25-.36.26.03.3.16.07.1.2.04.28,0,.2-.55.89-.62,1.22-1.05.36.13.08-.61.3-.06.44-.17.77.34.27.53-.04.63-.73.7-1.16.96-.13.49.13,1.09-.51,1.22-.11.08-.14-.1-.07-.14.59-.05.45-.69.35-1.04-.05-.11-.15.02-.22,0-.39-.21,0,.66-.25.57-.12.24-.64.21-.23.02.71-1.05-1.84-.5.1,1.06.12.08.17.04.23-.05.1.21.18.16.29.08.32.54,1.5.92,2.02.33.22-.86-.14-1.83.3-2.67.1-.13.26-.52-.05-.49.16-.06.14-.38.34-.46-.13-.02-.13-.14-.27-.18-.04-.11.06,0,.11-.02.12,0,.23-.19.21.03.09.02.2-.19.3-.08.08-.03-.07-.15.04-.16.06,0,.17-.1.15.03-.27.39.48-.26.67-.09-.01-.25.43-.33.6-.43.29-.25.64.16.88-.27.25-1.51,1.46-.46,2.55-.38.55.65-1.21-3.3-1.68-2.33-.21.04.06-.06.05-.16-.15-.08-.38-.18-.55-.15-.17.07-.84.19-.23-.04.43-.19,1.25.28,1.23-.28-.55-1.05-.13-2.39-1.03-1.44.14-.35.84-.59.64-1.03-.02-.55.27-1.33.78-1.58.13-.22,1.52-.47.75-.73-.17-.1-.11-.58-.4-.39-.31-.04-1.22.24-.54-.07.4.15.63-.03.65-.27-.05-.11-.1-.23-.15-.37-.02-.02-.03-.04-.04-.05-.15-.04-.14-.18.01-.03,0,.03.02.06.03.09.11.12.15.25.15.37.77,1.58,2.17.31,2.05-1.16,0-.2.4-1.1.08-.89,0,.25-.14.5-.38.37.18-.03.33-.18.23-.35.31-.19.23-.56.4-.85.53-.41.86-.88,1.31-1.32.28,0,.27-.15.41-.32.21-.32.73-.17.82-.51.05-.06.18.04.25,0-.14-.37.43-.4.48-.7.16-.19.41,0,.54-.14-.21-.12-.06-.26-.11-.43.12-.25.25.11.42-.04-.06-.11-.19-.17-.24-.36-.07-.61-.78.18-1.09.13-.01,0-.17-.05-.08-.04.47.05.69-.53,1.17-.36.83-1.34.11-2.39-1.47-2.26-.71.15-1.07-.66-1.48-1.08-.39-.06-.68-.55-.84-.81-.32-.64-.33-1.64.32-2,.05-.56.52-1.2,1.03-1.65.35-.18,1.17-.02.82-.35.51.19-.23-.16.51-.3.26.1.42-.35.76-.12.07.12.31.2.29.02.22.05.35.09.56.12.11-.05.05-.07.07-.15.13.07-.02-.06.04-.1.52-.25-.61-.19-.24-.53-.05-.4.51-.64.7-.6,0-.02.05-.1.05-.03.09-.01,0-.06-.04-.07-.03-.07.07-.03.07-.08-.08-.06.03-.07.08-.08.02.15,0-.01.08.03.06-.06-.02-.08-.07-.09.05-.06-.02-.06-.02-.1.02,0,.07-.04.04-.06.03-.03.07,0,.07-.05-.02-.09.16-.08.13-.18-.55-.95.2-.2-.07-1.11-.44-.69.17-1.52.63-2.14.28-.52,1.46-.37,1.51-.94-.49.13-1.25-.27-1.61-.6.28-.62,1.94-1.12,1.79-.09-.07.66.87.43,1.3.25.23-.47.34-1.24,0-1.68-.16-.98-.97.03-1.54.03.81,0,.99.62.06.54-.19.11-.48.05-.66,0,.14-.35.53-.58-.1-.55-1.14-.04-.84-.95-.9-1.65.23-.55-.37-1.27-.32-1.88-.04-.69.86-1.05.9-.69.36.22-.67,0-.16.18,1.63.19,3.04,1.65,4.69.6.71-.09,1.21-.61,1.44-1.19-.23.04-.34.22-.38-.05,0-.07.05.04.07.05.18.1.16-.14.12-.21-.23-.07-.44-.39-.52-.69.43-.32.24-.89.47-1.28-.19-.23.24.12.36-.04.05,0,.02-.27.03-.29.14-.48.15-.9-.35-1.08-.06-.45.44.4.54.12.12-.37-.86-.22-.59-.38.15.02-.1-.09-.12-.16-.04-.07.04-.2-.04-.26.03-.18.34-.41.06-.41-.44-1.18.88.31,1.43.07,2.89-.14,8.5-.33,9.68-3.16.93-1.11,2.54-2.7,1.63-4.12-.37.51-1.51-.54-1.39-1.27,1.97-2.24-2.52-2.29-2.46-3.86-.5-.33.33-.2.16-.78-.6-.75-.16-1.71-.11-2.47,1.17.04.31-.99.53-1.71.03.55.41,1.04.27,1.54-1.1.43-.38.26-.8,1.24-.28,1.12.82,1.61,1.33,2.39.59.15,1.59-.37,2.07.41.26.43,1.17.25,1.3.52-.23.09.21.32.3.27.79.04.77-.56,2.02-.27.24.4.78.08.97.43.15-.16,1.87-.57,1.41-.81-.07-.09.08-.09.11-.16.08-.04-.19-.1-.05-.09.21,0,.11.15.16.24.06.3.72-.67,1.09-.69-.11-.32.2-.55.4-.77.35-.32.08-.83.74-1.09,1.61-.86,1.6-2.76,2.7-3.87-.02-.12.01-.39-.11-.12-.2-.04.13-.14.13-.22-.12-.08-.13.1-.23.12-.21.03.01,0-.11-.07-.12.04-.02-.14-.02-.21.27-.08.23-.11.06-.25-.18.07.03-.22.01-.36.57-.16.24-.2.3-.44.38.53,0-.37.27-.51.08-.18.49-.22.73-.24-.06-.11-.03-.35.16-.34.53,0-.11-.65.48-.6.01-.14-.19-.67.09-.59.05.09.04.5.12.35-.42-.96.92-1.06.19-1.05,0-.27-.11-.06-.24-.22.11-.03.02-.19-.06-.12-.01-.14.07-.36.07-.52.14-.02.04.23.15.31-.03.13-.02.11.11.18-.03.19.28,0,.27.14.23.04-.15.28.27.41-.02-.4.3-.25.63-.39.06-.61.47.29.13.52-.57-.94.35.94-.84,1.05.13.11-.18.42.07.43-.02.03-.06.17-.15.14,0-.05,0-.24-.1-.17-.52-.01-.1.56-.37.89-.06.14-.43.44-.49.17-.17.25-.27.59-.74.78-.25-.03-.13.03-.21.15-.27.12-.87-.4-.4.24-.71.98,2.39-1.26,2.72-2.04,1.72-2.11,2.11-5.18,4.77-6.53-.29.15-.39-.72-.1-.34-.05.56.17.04.24-.2.15-.17.13-.46.19-.66-.06-.25.21-.42-.02-.58.02-.07-.03-.18-.05-.28-.06-.14.23-.11.11-.24-.11-.04-.21-.33,0-.34.09-.09.14-.24-.04-.28-.11-.11.08-.39.22-.26-.07.05,0,.08.06.03,0-.05-.05-.1.02-.14-.06.01-.08-.12-.13-.06-.11.23-.23-.15-.1-.24.02-.09-.17-.11-.1-.24-.02-.11-.04-.26.09-.35,0-.09-.18-.02-.23-.13.27-1.32-.11-.55-.2-1.21.05-.12-.08-.22-.08-.34.14-.07.05.73.49.17-.14-.38.29-.82-.37-.68-.31-.07.66-.01.28-.13.34.08.19-.15.43-.47.38-.2-.09-.18-.16-.12.2-.12-.16-.17-.24-.07-.01-.06-.12-.03-.1-.09.09,0,.06-.03,0-.03-.05.03-.19.01-.18-.06.08.04.13-.02.07-.07-.06-.03-.09-.15-.1-.2.25.32.8.4.71.01-.02-.05-.22-.05-.1-.06.24,0-.08-.39.22-.08.13.04-.02-.06.07-.11.1-.12.02.56.15.09,0,.14.44-.11.34,0-.32,0-.27.64-.14.3.24-.37,1.14-.83.33-.87.06-.05.27-.19.54-.36.2-.18.53-.33.69-.47.03,0,.04,0,.05,0,.33-.21.67-.42.95-.59.21-.11.27-.55.78-.65.18-.2.82-.32.85-.44-.08-.02-.14-.08-.19-.15.01,0,.14.04.1,0,.04-.24.47.09.21.22.14-.05.42-.02.36-.23.18-.22.02-.1-.05-.03-.3.09.11-.04.08-.15.04.03.1-.02.15-.04.4-.46,1.68.37,1.56-.25-.31-.22.28-.34.4-.33.11,0-.02-.09.05-.13.05,0,.07.03.13.01-.03-.14,0-.06.13-.03-.04-.06.03-.06.05,0-.01-.09.17-.12.11-.16-.14-.06-.02-.07.05-.1.05,0,.29-.25.24-.09.15.01.3.08.45-.05.23.04.31-.05.47-.11.02-.11-.27-.05-.13-.16-.11-.04-.28.23-.19.05.1-.06-.08-.06-.09,0,.15-.14.08-.16-.06-.08-.06-.39.2-.41.51-.46.15,0,.11-.24.24-.17.07.1.03-.12.13-.06.04,0,0,.02,0,.03.12.06-.22.24.06.14,0,.1.11-.07.14.03-.02.08.03.12.1.06.36.02.51-.49.9-.24.58.11.37.33-.07.28-.08-.04-.17-.06-.19.02-.06-.06-.28-.05-.2.08.33-.1,1-.05,1.28-.17,1.41.03-.18-.64.79-.76.5-.23-.2.54,0,.58.74.1,1.93.02,2.51-.02-.15.04.01-.14.03-.17,0-.15.24-.14.29-.25-.89-.12.42-1.19.93-1.28,1.31-.22,1.11-.6,1.01-1.12H26.58Z"
                      />
                      <path
                        class="cls-1"
                        d="m86.17,80.11c-.27-.09.08-.04-.17-.11,0,0-.34.2-.29.24.07-.01.01.03.04.06.05.09.04-.06.1-.08.15.07.52.01.44-.06-.07-.11-.01-.06-.12-.05Z"
                      />
                      <path
                        class="cls-1"
                        d="m10.62,20.59s.02-.01.03-.02c-.03.01-.03.02-.03.02Z"
                      />
                      <path
                        class="cls-1"
                        d="m20.07,163.43s.02-.03.04-.05c-.03.02-.04.03-.04.05Z"
                      />
                      <path
                        class="cls-1"
                        d="m81.19,81.98c-.06.01-.17-.06-.14.03-.21.05.47.24.14-.03Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.63,144.08c-.11.06,0,.25.03.29.33-.14.44-.56-.03-.29Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.54,143.9c-.08.27-.17-.25-.32.12-.22.67.9.03.32-.12Z"
                      />
                      <path
                        class="cls-1"
                        d="m17.5,148.58c.29-.06-.24-.5-.37-.33.05.13.23.27.37.33Z"
                      />
                      <path
                        class="cls-1"
                        d="m16.76,146.83c.28.22.76.06,1.06-.04.15-.11-.08.29.27.04.38-.25-1.51-.58-.99-.25.08.12-.11-.03-.14-.05-.17-.15-.61.36-.21.3Z"
                      />
                      <path
                        class="cls-1"
                        d="m75.74,87.64c.17.16.23.4.36.08.29-.53-.11-.39-.36-.08Z"
                      />
                      <path
                        class="cls-1"
                        d="m18.18,157.89c-.09-.1-.37.12-.25.19.08.01.27-.09.09.04-.25.25.52.11.15-.23Z"
                      />
                      <path
                        class="cls-1"
                        d="m19.24,162.91c-.05.02-.2.1-.13.15.04-.03.14-.11.13-.15Z"
                      />
                      <path
                        class="cls-1"
                        d="m43.24,6.53s.05,0,.06,0h0s-.04,0-.06,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m83.26,31.78s0,0-.01-.01c-.06.01-.03.01.01.01Z"
                      />
                      <path
                        class="cls-1"
                        d="m68.63,31.39c-.37.68-.49,1.23.57.38.49-.44.97-.92.85-1.45-.05-.07-.28-.34-.32-.13.14.19-.04-.02-.01.09-.02-.13-.15.31-.07.03.05-.39-.44.18-.83.79-.02.12-.07.22-.17.3Z"
                      />
                      <path
                        class="cls-1"
                        d="m68.8,31.09c-.06.1-.12.2-.17.3.1-.07.15-.18.17-.3Z"
                      />
                      <polygon
                        class="cls-1"
                        points="47.71 9.53 47.72 9.52 47.71 9.52 47.71 9.53"
                      />
                      <path
                        class="cls-1"
                        d="m47.33,9.82c.11-.09.24-.2.37-.29,0,0,0,0,0,0,0,0,0,0,0,0,.05-.03.09-.07.14-.09.03-.12-.33.06-.48.23-.02.04-.04.07-.06.11,0,.02,0,.04.01.05Z"
                      />
                      <path
                        class="cls-1"
                        d="m77.61,84.62c.02-.26,1-.76.9-.8-.27.17-.52.33-.74.47-.11.1-.18.21-.16.33Z"
                      />
                      <path
                        class="cls-1"
                        d="m47.32,9.97c.25-.01.84-.42.4-.45,0,0,0,0,0,0-.11.14-.2.35-.39.44Z"
                      />
                      <path
                        class="cls-1"
                        d="m22.9,2.12s.06-.04.08-.06c-.02,0-.05.02-.08.06Z"
                      />
                      <path
                        class="cls-1"
                        d="m85.77,35.08s0-.04.01-.06c-.01.02-.02.04-.01.06Z"
                      />
                      <polygon
                        class="cls-1"
                        points="83.26 31.78 83.27 31.78 83.27 31.78 83.26 31.78"
                      />
                      <path
                        class="cls-1"
                        d="m85.7,34.68s.01.03.03.04c0-.05-.01-.05-.03-.04Z"
                      />
                      <path
                        class="cls-1"
                        d="m83.36,32.32s0,0,0,0c-.03.06-.02.04,0,0Z"
                      />
                      <path
                        class="cls-1"
                        d="m15.61,140.46c-.58-.53-.5.33-.12.19.31.13.23.09-.05.07-.9.54.99.34.54-.61-.11.09-.22-.07-.18.13-.11.04-.17.16-.27.02-.2.02.44.29.08.21Z"
                      />
                      <path
                        class="cls-1"
                        d="m105.16,49.91s.01.02.02.03c0-.01-.01-.02-.02-.03Z"
                      />
                      <path
                        class="cls-1"
                        d="m98.01,58.39c.06.12.15.24.21.27-.1-.16.12-.62-.1-.61-.21-.07-.22.07-.17.23.02.02.04.05.05.11Z"
                      />
                      <path
                        class="cls-1"
                        d="m97.96,58.28s.03.07.05.11c0-.05-.02-.09-.05-.11Z"
                      />
                      <path
                        class="cls-1"
                        d="m101.51,53.57c.05.04.07.06.09.07-.02-.03-.05-.06-.09-.07Z"
                      />
                    </clipPath>
                  </defs>
                  <rect
                    width="100%"
                    height="100%"
                    fill="black"
                    clip-path="url(#shapeClip)"
                  />
                  <rect
                    id="fillRect"
                    width="100%"
                    y="100%"
                    height="0%"
                    fill="#F2D86A"
                    clip-path="url(#shapeClip)"
                  ></rect>
                </svg>
              </div>
            </div>
            <div class="methane-intro-stats-col methane-intro-stats-col-2">
              <span>{{
                pageContent.data.attributes.MethanePercentTitleTop
              }}</span>

              <span
                class="stat-value stat-value-percent animated-value"
                :data-final-value="
                  pageContent.data.attributes.MethanePercentValue
                "
                ref="elRef"
                >0%</span
              >
              <span>{{
                pageContent.data.attributes.MethanePercentTitleBottom
              }}</span>
            </div>
            <div class="methane-intro-stats-col methane-intro-stats-col-3">
              <span>{{
                pageContent.data.attributes.MethaneTotalTitleTop
              }}</span>
              <span
                class="stat-value stat-value-number animated-value"
                :data-final-value="
                  pageContent.data.attributes.MethaneTotalValue
                "
                >0</span
              >
              <span>{{
                pageContent.data.attributes.MethaneTotalTitleBottom
              }}</span>
            </div>
          </div>
          <div
            class="intro-content-top md-content"
            v-html="md.render(pageContent.data.attributes.IntroContent)"
          ></div>
          <div
            class="notes references-content"
            v-html="
              md.render(pageContent.data.attributes.IntroReferencesContentHTML)
            "
          ></div>
        </div>
      </div>
      <div class="methane-solutions">
        <div class="content-container-1140">
          <div class="d-flex methane-solutions-inner">
            <div class="methane-solutions-col methane-solutions-col-1">
              <h2>{{ pageContent.data.attributes.MethaneSolutionsTitle }}</h2>
              <div
                class="md-content"
                v-html="
                  md.render(
                    pageContent.data.attributes.MethaneSolutionsDescription
                  )
                "
              ></div>
              <nuxt-link
                class="btn-green btn-bg-white"
                :to="localePath({ name: 'solutions_overview-sector' })"
                >{{
                  pageContent.data.attributes.MethaneSolutionsButtonText
                }}</nuxt-link
              >
            </div>
            <div class="methane-solutions-col methane-solutions-col-2">
              <div
                class="methane-solutions-learn-more md-content"
                v-html="
                  md.render(
                    pageContent.data.attributes.MethaneSolutionsLearnMore
                  )
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="methane-bad">
        <div class="content-container-1140">
          <div class="d-flex methane-bad-inner">
            <div class="methane-bad-col methane-bad-col-1">
              <h2>{{ pageContent.data.attributes.MethaneBadTitle }}</h2>
              <div
                class="md-content"
                v-html="
                  md.render(pageContent.data.attributes.MethaneBadDescription)
                "
              ></div>
            </div>
            <div class="methane-bad-col methane-bad-col-2">
              <nuxt-img
                :src="
                  pageContent.data.attributes.MethaneBadImage.data.attributes
                    .url
                "
                :alt="
                  pageContent.data.attributes.MethaneBadImage.data.attributes
                    .alternativeText
                "
              ></nuxt-img>
            </div>
          </div>
        </div>
      </div>
      <div class="methane-attention">
        <div class="content-container-1140">
          <div class="d-flex methane-attention-inner">
            <div class="methane-attention-col methane-attention-col-1">
              <div
                class="md-content"
                v-html="
                  md.render(
                    pageContent.data.attributes.MethaneAttentionDescription
                  )
                "
              ></div>
            </div>
            <div class="methane-attention-col methane-attention-col-2">
              <mapbox-map
                container="map"
                :year="currentYear"
                :attribution-control="false"
                map-type="pledges"
                ref="map"
              ></mapbox-map>
              <div
                class="methane-attention-stat"
                v-html="pageContent.data.attributes.MethaneAttentionStat"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="methane-south-america">
        <div class="methane-south-america-image-wrapper">
          <figure>
            <nuxt-img
              :src="
                pageContent.data.attributes.MethaneSouthAmericaImage.data
                  .attributes.url
              "
              :alt="
                pageContent.data.attributes.MethaneSouthAmericaImage.data
                  .attributes.alternativeText
              "
            ></nuxt-img>
            <figcaption>
              {{ pageContent.data.attributes.MethaneSouthAmericaImageCaption }}
            </figcaption>
          </figure>
          <h2>
            <span>{{
              pageContent.data.attributes.MethaneSouthAmericaImageDescription
            }}</span>
          </h2>
        </div>
        <div class="methane-south-america-stats">
          <div class="content-container-1140">
            <div class="methane-south-america-stats-inner">
              <h2>
                {{ pageContent.data.attributes.MethaneSouthAmericaTitle }}
              </h2>
              <div
                class="md-content"
                v-html="
                  md.render(
                    pageContent.data.attributes.MethaneSouthAmericaDescription
                  )
                "
              ></div>
              <h3 class="text-center mb-8">
                {{ pageContent.data.attributes.MethaneSourcesTitle }}
              </h3>
              <div class="methane-emissions-bars">
                <div class="bar-agriculture bar-wrapper d-flex align-center">
                  <span class="sector">{{
                    pageContent.data.attributes.MethaneSourcesAgricultureTitle
                  }}</span>
                  <div
                    class="value-bar animated-barchart"
                    :data-final-value="
                      pageContent.data.attributes
                        .MethaneSourcesAgriculturePercentValue
                    "
                    data-current-value="0%"
                  ></div>
                  <span class="value-text">{{
                    pageContent.data.attributes
                      .MethaneSourcesAgricultureValueDescription
                  }}</span>
                </div>
                <div class="bar-waste bar-wrapper d-flex align-center">
                  <span class="sector">{{
                    pageContent.data.attributes.MethaneSourcesWasteTitle
                  }}</span>

                  <div
                    class="value-bar animated-barchart"
                    :data-final-value="
                      pageContent.data.attributes
                        .MethaneSourcesWastePercentValue
                    "
                    data-current-value="0%"
                  ></div>
                  <span class="value-text">{{
                    pageContent.data.attributes
                      .MethaneSourcesWasteValueDescription
                  }}</span>
                </div>
                <div class="bar-energy bar-wrapper d-flex align-center">
                  <span class="sector">{{
                    pageContent.data.attributes.MethaneSourcesEnergyTitle
                  }}</span>
                  <div
                    class="value-bar animated-barchart"
                    :data-final-value="
                      pageContent.data.attributes
                        .MethaneSourcesEnergyPercentValue
                    "
                    data-current-value="0%"
                  ></div>
                  <span class="value-text">{{
                    pageContent.data.attributes
                      .MethaneSourcesEnergyValueDescription
                  }}</span>
                </div>
              </div>
              <div class="methane-emissions-info">
                <div class="methane-emissions-info-notes">
                  <v-icon
                    icon="$circleInfoSolid"
                    title="Some information here"
                  ></v-icon>
                  Data below: percentage of sector emissions
                </div>
                <div
                  class="methane-emissions-info-title methane-emissions-info-title-agriculture"
                >
                  <v-icon icon="$cowFree"></v-icon>
                  <h3>
                    {{
                      pageContent.data.attributes.MethaneSourcesAgricultureTitle
                    }}
                  </h3>
                </div>
                <div class="methane-emissions-info-agriculture">
                  <div
                    class="methane-emissions-info-agriculture-col methane-emissions-info-agriculture-col-1"
                  >
                    <div
                      class="methane-emissions-info-agriculture-intro d-flex align-center"
                    >
                      <div
                        class="methane-emissions-livestock-value animated-value"
                        :data-final-value="
                          pageContent.data.attributes
                            .MethaneEmissionsLivestockValue
                        "
                      >
                        0%
                      </div>
                      <div
                        class="methane-emissions-livestock-description"
                        v-html="
                          pageContent.data.attributes
                            .MethaneEmissionsLivestockDescription
                        "
                      ></div>
                    </div>
                    <div class="methane-emissions-cow">
                      <div
                        class="methane-emissions-cow-col methane-emissions-cow-col-1"
                      >
                        <span class="description">{{
                          pageContent.data.attributes
                            .MethaneEmissionsBurpingDescription
                        }}</span>
                        <span class="description-small">{{
                          pageContent.data.attributes
                            .MethaneEmissionsBurpingDescriptionSmall
                        }}</span>
                      </div>
                      <div
                        class="methane-emissions-cow-col methane-emissions-cow-col-2"
                      >
                        <div class="methane-emissions-cow-wrapper">
                          <img
                            src="/images/cow-outline.png"
                            alt="Cow outline"
                          />
                          <span
                            class="methane-emissions-cow-value animated-value"
                            :data-final-value="
                              pageContent.data.attributes
                                .MethaneEmissionsBurpingValue
                            "
                            >0%</span
                          >
                        </div>
                      </div>
                      <div
                        class="methane-emissions-cow-col methane-emissions-cow-col-3"
                      >
                        <div class="methane-emissions-manure">
                          <div class="methane-emissions-manure-wrapper">
                            <img
                              src="/images/cow-manure.png"
                              alt="Cow manure"
                            />
                            <span
                              class="methane-cow-manure-value animated-value"
                              :data-final-value="
                                pageContent.data.attributes
                                  .MethaneEmissionsManureValue
                              "
                              >0%</span
                            >
                          </div>
                          <div class="methane-cow-manure-description-wrapper">
                            <span class="description">{{
                              pageContent.data.attributes
                                .MethaneEmissionsManureDescription
                            }}</span>
                            <span class="description-small">{{
                              pageContent.data.attributes
                                .MethaneEmissionsManureDescriptionSmall
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="methane-emissions-info-agriculture-col methane-emissions-info-agriculture-col-2"
                  >
                    <div class="methane-emissions-rice">
                      <div
                        class="methane-emissions-rice-col methane-emissions-rice-col-1"
                      >
                        <img
                          src="/images/rice-icon.png"
                          alt="Rice cultivation icon"
                        />
                      </div>
                      <div
                        class="methane-emissions-rice-col methane-emissions-rice-col-2"
                      >
                        <p class="methane-emissions-rice-title">
                          {{
                            pageContent.data.attributes
                              .MethaneEmissionsRiceTitle
                          }}
                        </p>
                        <span
                          class="methane-emissions-rice-value animated-value"
                          :data-final-value="
                            pageContent.data.attributes
                              .MethaneEmissionsRiceValue
                          "
                          >0%</span
                        >
                      </div>
                    </div>
                    <div class="methane-emissions-waste">
                      <div
                        class="methane-emissions-waste-col methane-emissions-waste-col-1"
                      >
                        <img
                          src="/images/burn-icon.png"
                          alt="waste cultivation icon"
                        />
                      </div>
                      <div
                        class="methane-emissions-waste-col methane-emissions-waste-col-2"
                      >
                        <p class="methane-emissions-waste-title">
                          {{
                            pageContent.data.attributes
                              .MethaneEmissionsBurningTitle
                          }}
                        </p>
                        <span
                          class="methane-emissions-waste-value animated-value"
                          :data-final-value="
                            pageContent.data.attributes
                              .MethaneEmissionsBurningValue
                          "
                          >0%</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="methane-emissions-info-energy-waste">
                  <div
                    class="methane-emissions-info-energy-waste-col methane-emissions-info-energy-waste-col-1"
                  >
                    <div
                      class="methane-emissions-info-energy-col methane-emissions-info-energy-col-1"
                    >
                      <div
                        class="methane-emissions-info-title methane-emissions-info-title-energy"
                      >
                        <v-icon icon="$industry"></v-icon>
                        <h3>
                          {{
                            pageContent.data.attributes
                              .MethaneSourcesEnergyTitle
                          }}
                        </h3>
                      </div>
                      <div class="methane-emissions-energy-leaks">
                        <div
                          class="methane-emissions-energy-leaks-col methane-emissions-energy-leaks-col-1"
                        >
                          <div
                            class="methane-emissions-energy-leaks-image-wrapper"
                          >
                            <img
                              src="/images/leak-icon.png"
                              alt="Pipe leak icon"
                            />
                            <span
                              class="methane-emissions-energy-leaks-value animated-value"
                              :data-final-value="
                                pageContent.data.attributes
                                  .MethaneEmissionsLeaksValue
                              "
                              >0%</span
                            >
                          </div>
                        </div>
                        <div
                          class="methane-emissions-energy-leaks-col methane-emissions-energy-leaks-col-2"
                        >
                          <div
                            class="methane-emissions-energy-leaks-description"
                          >
                            <span class="description">{{
                              pageContent.data.attributes
                                .MethaneEmissionsLeaksDescription
                            }}</span>
                            <span class="description-small">{{
                              pageContent.data.attributes
                                .MethaneEmissionsLeaksDescriptionSmall
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="methane-emissions-info-energy-col methane-emissions-info-energy-col-2"
                    >
                      <div
                        class="methane-emissions-energy-burning-fuel-image-wrapper"
                      >
                        <img
                          src="/images/burning-fuel-icon.png"
                          alt="Burning fuel icon"
                        />
                        <span
                          class="methane-emissions-energy-burning-fuel-value animated-value"
                          :data-final-value="
                            pageContent.data.attributes
                              .MethaneEmissionsBurningFuelsValue
                          "
                          >0%</span
                        >
                      </div>
                      <p
                        class="methane-emissions-energy-burning-fuel-description"
                      >
                        {{
                          pageContent.data.attributes
                            .MethaneEmissionsBurningFuelsDescription
                        }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="methane-emissions-info-energy-waste-col methane-emissions-info-energy-waste-col-2"
                  >
                    <div class="methane-emissions-info-waste">
                      <div
                        class="methane-emissions-info-waste-col methane-emissions-info-waste-col-1"
                      >
                        <div
                          class="methane-emissions-info-title methane-emissions-info-title-waste"
                        >
                          <v-icon icon="$appleCoreSolid"></v-icon>
                          <h3>
                            {{
                              pageContent.data.attributes
                                .MethaneSourcesWasteTitle
                            }}
                          </h3>
                        </div>
                        <div class="methane-emissions-waste-landfills">
                          <div
                            class="methane-emissions-waste-landfills-image-wrapper"
                          >
                            <img
                              src="/images/landfill-icon.png"
                              alt="Landfill icon"
                            />
                            <span
                              class="methane-emissions-waste-landfills-value animated-value"
                              :data-final-value="
                                pageContent.data.attributes
                                  .MethaneEmissionsLandfillsValue
                              "
                            ></span>
                          </div>
                          <p
                            class="methane-emissions-waste-landfills-description"
                          >
                            {{
                              pageContent.data.attributes
                                .MethaneEmissionsLandfillsDescription
                            }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="methane-emissions-info-waste-col methane-emissions-info-waste-col-2"
                      >
                        <div class="methane-emissions-wastewater-image-wrapper">
                          <img
                            src="/images/wastewater-icon.png"
                            alt="Wastewater icon"
                          />
                          <span
                            class="methane-emissions-wastewater-value animated-value"
                            :data-final-value="
                              pageContent.data.attributes
                                .MethaneEmissionsWastewaterValue
                            "
                          ></span>
                        </div>
                        <div class="methane-emissions-wastewater-description">
                          <p>
                            {{
                              pageContent.data.attributes
                                .MethaneEmissionsWastewaterDescription
                            }}
                          </p>
                          <img src="/images/waves-icon.png" alt="Waves icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="methane-how">
        <div class="content-container-1140">
          <h2>{{ pageContent.data.attributes.MethaneHowTitle }}</h2>
          <div
            class="methane-how-content md-content"
            v-html="
              md.render(pageContent.data.attributes.MethaneHowDescription)
            "
          ></div>
          <nuxt-link
            class="btn-green btn-bg-white"
            :to="localePath({ name: 'solutions_overview-sector' })"
            >{{ $t("solutions.exploreSolutions") }}</nuxt-link
          >
        </div>
      </div>
      <div
        class="methane-references"
        v-if="pageContent.data.attributes.MethaneReferences"
      >
        <div class="content-container-1140">
          <div
            class="methane-references-content references-content"
            v-html="md.render(pageContent.data.attributes.MethaneReferences)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
const { locale, t } = useI18n();
const { md } = useMarkdownIt();
const { scenarios } = usePathwaysConfig();

useHead({
  title: t('navigation.routeTitles.methane101')
})

// ref for the mapbox map
const map = ref(null);
// the data year to display
const currentYear = ref(new Date().getFullYear());

// api content
const contentType = "methane";
const key = `${contentType}_${locale.value}`;
const apiURL = getStrapiLink(contentType, {
  populate: [
    "BannerImage",
    "MethaneBadImage",
    "MethaneAttentionImage",
    "MethaneSouthAmericaImage",
  ],
});
const { data: pageContent } = await useFetch(apiURL, {
  key: key,
  watch: false,
});

// // Add class when element is in viewport (25% in)
if (process.client) {
  // only perform on client (window, document not available to ssr process)
  window.addEventListener("scroll", () => {
    const windowHeight = window.pageYOffset + window.innerHeight;
    const elements = document.querySelectorAll(".toAnimate");

    elements.forEach((element) => {
      const elementTop =
        element.getBoundingClientRect().top + window.pageYOffset;
      const elementBottom = elementTop + element.getBoundingClientRect().height;
      const elementQuarter =
        elementTop + element.getBoundingClientRect().height * 0.75;

      if (elementQuarter < windowHeight && elementBottom > window.pageYOffset) {
        element.classList.add("active");
      }
    });
  });
}

const observer = ref(null);
let animationIntervalIDs = [];
let elements = ref([]);

const startAnimation = (el) => {
  if (el.classList.contains("animated")) {
    return;
  }

  let finalValue = parseFloat(
    el.getAttribute("data-final-value").replace(",", "")
  );
  let currentValue = 0;

  // Set the duration and calculate the step size
  let duration = 3000; // duration in milliseconds
  let intervalFrequency = 50; // frequency of interval in milliseconds
  let steps = duration / intervalFrequency; // total number of steps
  let stepSize = finalValue / steps; // size of each step

  let intervalId = setInterval(() => {
    currentValue += stepSize;
    if (currentValue < finalValue) {
      el.setAttribute(
        "data-current-value",
        formatNumber(
          currentValue.toFixed(0),
          el.getAttribute("data-final-value")
        )
      );
      if (el.classList.contains("animated-barchart")) {
        el.style.width = currentValue.toFixed(2) + "%";
      } else {
        el.innerText = formatNumber(
          currentValue.toFixed(0),
          el.getAttribute("data-final-value")
        );
      }
    } else {
      el.setAttribute(
        "data-current-value",
        formatNumber(finalValue.toFixed(0), el.getAttribute("data-final-value"))
      );
      if (el.classList.contains("animated-barchart")) {
        el.style.width = finalValue.toFixed(2) + "%";
      } else {
        el.innerText = formatNumber(
          finalValue.toFixed(0),
          el.getAttribute("data-final-value")
        );
      }
      clearInterval(intervalId);
      const index = animationIntervalIDs.indexOf(intervalId);
      if (index > -1) {
        animationIntervalIDs.splice(index, 1);
      }
    }
  }, intervalFrequency);

  animationIntervalIDs.push(intervalId);
  el.classList.add("animated");
};

const formatNumber = (number, finalValue) => {
  let isPercent = finalValue.includes("%");
  let isComma = finalValue.includes(",");
  let displayValue = isPercent ? number + "%" : number;
  if (isComma) {
    displayValue = parseFloat(number).toLocaleString(locale.value);
  }
  return displayValue;
};

onMounted(() => {
  if (process.client) {
    // only perform on client (window, document not available to ssr process)
    elements.value = document.querySelectorAll(
      ".animated-value, .animated-barchart"
    );
    observer.value = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startAnimation(entry.target);
          }
        });
      },
      { threshold: 1.0 }
    );

    elements.value.forEach((el) => {
      observer.value.observe(el);
    });
  }

  if (map.value !== null) {
    map.value.updateMapCH4Data(scenarios.bau.data);
    map.value.flyToSA();
    setTimeout(map.value.flyToSA(), 1000);
  }
});

onBeforeUnmount(() => {
  if (observer.value) {
    observer.value.disconnect();
  }
  animationIntervalIDs.forEach((id) => clearInterval(id));
});
</script>

<style lang="scss" scoped>
.content-container-1300 {
  max-width: 1300px !important;
  margin-left: auto;
  margin-right: auto;
}

.hero-banner-methane {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  max-width: 100%;
  max-height: 865px;
  height: 100vw;
  position: relative;
  overflow: hidden;

  @media (max-width: 1279px) {
    max-height: 40vw;
  }

  @media (max-width: 599px) {
    max-height: 60vw;
  }
}

.hero-banner-methane-content {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  width: calc(((100% - 1140px) / 2) + ((1140px * 0.6) + 45px));
  max-width: none;
  padding: 75px 0px 10px 0px;

  @media (max-width: 1279px) {
    display: none;
  }

  .methane-overlap-conntainer {
    width: calc((1140px * 0.6) + 45px);
    margin-left: 0px;
    margin-right: 0px !important;
  }
  .hero-banner-methane-content-inner {
    padding: 0px 45px 0px 0px;
    margin-left: 0px;
  }
}

.hero-banner-methane-content-inner,
.methane-overlap-content {
  h1 {
    font-size: clamp(50px, 5.5vw, 60px);
    line-height: 1.1;
    margin-bottom: 50px;
  }

  p {
    font-size: 23px;
    font-weight: 500;
    line-height: 1.4;
  }
}
.methane-overlap-content {
  padding-top: 40px;
}

h2 {
  font-size: 39px;
  font-weight: 700;
  line-height: 1.18;
  margin-bottom: 30px;
}
p {
  font-size: 21px;
  line-height: 1.5;
  font-weight: 500;
}
p:not(:last-child) {
  margin-bottom: 30px;
}
a {
  text-decoration: underline;
  color: inherit;
}
a:hover {
  text-decoration: underline dotted;
}
.methane-intro,
.hero-banner-methane-content {
  background-color: #cb5546;
}

.methane-overlap-content {
  display: none;

  @media (max-width: 1279px) {
    display: block;
  }
}
.methane-intro {
  padding: 10px 20px 30px;

  .notes {
    p {
      font-size: 16px;
      font-weight: 400;
    }
  }
  p {
    max-width: 650px;
  }
  .methane-intro-stats {
    padding: 50px 0;

    @media (max-width: 599px) {
      flex-wrap: wrap;

      .methane-intro-stats-col-1 {
        text-align: center;

        svg {
          max-width: 200px;
        }
      }
    }
  }
  .methane-intro-stats-col {
    width: 18%;

    @media (max-width: 1279px) {
      width: 25%;
    }

    @media (max-width: 599px) {
      width: 100%;
    }

    span:not(.stat-value) {
      font-size: 21px;
      font-weight: 500;
    }
  }

  .methane-intro-stats-col:not(:first-child) {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  .stat-value {
    font-size: 42px;
    font-weight: 700;
    line-height: 1;
    color: #f2d86a;
    padding: 20px 0;
  }
}

.methane-intro-stats-col:not(:last-child) {
  @media (max-width: 599px) {
    margin-bottom: 50px;
  }
}

.methane-solutions {
  padding: 80px 20px;
  background-color: #e8f7f4;

  h2 {
    color: #33a390;
  }

  .methane-solutions-inner {
    @media (max-width: 599px) {
      flex-direction: column-reverse;
    }
  }

  .methane-solutions-col-1 {
    width: 60%;
    padding-right: 60px;

    .md-content p {
      font-size: 21px !important;
      font-weight: 500 !important;
    }

    @media (max-width: 599px) {
      width: 100%;
    }
  }

  .methane-solutions-col-2 {
    width: 40%;

    @media (max-width: 599px) {
      width: 100%;
      margin-bottom: 40px;
    }
    .methane-solutions-learn-more {
      max-width: 350px;
      height: 100%;
      margin-left: auto;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px;
      position: relative;

      @media (max-width: 599px) {
        margin: 0;
        min-height: 300px;
      }

      &:after {
        content: "";
        position: absolute;
        background-image: url(/images/solutions-image@2x.png);
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
      }
    }
  }
}

.methane-bad {
  padding: 80px 20px 140px;
  background-color: #f2d86a;

  .methane-bad-inner {
    @media (max-width: 599px) {
      flex-direction: column-reverse;
    }
  }
  .methane-bad-col-1 {
    width: 60%;
    padding-right: 60px;

    @media (max-width: 599px) {
      width: 100%;
      padding: 0;
    }
  }

  .methane-bad-col-2 {
    width: 40%;

    @media (max-width: 599px) {
      width: 100%;
      margin-bottom: 40px;
    }
  }
}
.methane-attention {
  padding: 90px 20px;
}

.methane-attention-inner {
  @media (max-width: 599px) {
    flex-direction: column-reverse;
  }
}
.methane-attention-col-1 {
  width: 60%;
  padding-right: 30px;

  @media (max-width: 599px) {
    width: 100%;
    padding: 0;
  }
}
.methane-attention-col-2 {
  width: 40%;
  padding: 0 40px;
  position: relative;

  @media (max-width: 599px) {
    width: 100%;
    margin-bottom: 40px;
  }

  img {
    max-width: 220px;
  }

  .methane-attention-stat {
    font-size: clamp(16px, 2vw, 22px);
    font-weight: 700;
    font-style: italic;
    width: 40%;
    display: block;
    position: absolute;
    left: 60%;
    bottom: 30px;
  }
}

.methane-south-america-image-wrapper {
  position: relative;

  figure {
    line-height: 0;

    img {
      max-height: 575px;
    }
  }

  figcaption {
    background-color: #000000;
    width: fit-content;
    padding: 10px;
    color: #ffffff;
    z-index: 10;
    position: absolute;
    bottom: -18px;
    left: 20.5vw;
    left: calc(50% - min(50vw, 570px));
    line-height: 1.2;

    @media (max-width: 1180px) {
      left: 20px;
      font-size: 12px;
    }
  }

  h2 {
    position: absolute;
    z-index: 1;
    top: 30%;
    left: 60%;
    color: #ffffff;
    padding: 10px;
    font-style: italic;
    font-weight: 500;
    max-width: 420px;
    display: inline;
    line-height: 1.35;
    font-size: clamp(16px, 4vw, 35px) !important;

    span {
      background-image: linear-gradient(#fff 0%, #050505 0);
      background-size: auto 200%;
    }
    @media (max-width: 599px) {
      top: 15%;
      left: 50%;
    }
  }
}

.methane-south-america-stats {
  padding: 100px 20px;
  background-color: #fff8e8;

  .bar-wrapper {
    @media (max-width: 1023px) {
      flex-wrap: wrap;
    }
  }
  .bar-wrapper:not(:last-child) {
    margin-bottom: 20px;

    @media (max-width: 1023px) {
      margin-bottom: 60px;
    }
  }

  .methane-emissions-bars {
    padding-bottom: 70px;
    border-bottom: 1px solid #247775;
  }
  .methane-emissions-bars .value-bar {
    height: 65px;
    position: relative;
    border: 1px solid #000000;
  }
  .methane-emissions-bars .value-bar.animated-barchart {
    overflow: hidden;

    @media (max-width: 1023px) {
      overflow: unset;
    }
  }
  .methane-emissions-bars .value-bar.animated-barchart::after {
    color: #000000;
    content: attr(data-current-value);
    font-size: 29px;
    font-weight: 700;
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);

    @media (max-width: 1023px) {
      left: unset;
      right: -65px;
    }
  }

  .methane-emissions-bars .bar-agriculture .value-bar {
    background-color: #33a390;
  }
  .methane-emissions-bars .bar-waste .value-bar {
    background-color: #c94b3b;
  }
  .methane-emissions-bars .bar-energy .value-bar {
    background-color: #f2d86a;
  }
  .methane-emissions-bars .value-bar::after {
    color: #000000;
    content: attr(data-percentage);
    font-size: 29px;
    font-weight: 700;
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);

    @media (max-width: 1023px) {
      left: unset;
      right: -65px;
    }
  }
  .sector {
    font-size: 23px;
    font-weight: 500;
    width: 110px;
    text-align: right;
    margin-right: 20px;

    @media (max-width: 1023px) {
      text-align: left;
      width: 100%;
    }
  }

  .value-text {
    font-size: 22px;
    font-weight: 500;
    width: 20%;
    margin-left: 20px;

    @media (max-width: 1023px) {
      font-size: 18px;
      width: 100%;
      margin-left: 0;
      margin-top: 10px;
    }
  }
}

.methane-emissions-info {
  .methane-emissions-info-notes {
    padding: 20px 0 70px;

    .v-icon {
      margin-right: 3px;
      vertical-align: bottom;
    }
  }
  .methane-emissions-info-title {
    display: flex;
    align-items: center;
    text-transform: uppercase;
    width: fit-content;
    padding: 5px 10px;
    line-height: 1;
    font-size: clamp(20px, 2vw, 30px);

    i {
      margin-right: 15px;
    }

    &.methane-emissions-info-title-agriculture {
      margin-bottom: 60px;
      background-color: #33a390;
    }
    &.methane-emissions-info-title-energy {
      background-color: #f2d86a;
      margin-bottom: 60px;
    }
    &.methane-emissions-info-title-waste {
      background-color: #c94b3b;
      margin-bottom: 40px;
    }
  }

  .methane-emissions-info-agriculture {
    display: flex;
    padding-bottom: 50px;
    border-bottom: 1px solid #247775;

    @media (max-width: 1299px) {
      flex-direction: column;
    }
  }
  .methane-emissions-info-agriculture-col-1 {
    margin-bottom: 80px;

    @media (min-width: 1300px) {
      width: 65%;
      margin-bottom: 0;
    }

    .methane-emissions-info-agriculture-intro {
      margin-bottom: 60px;
    }
    .methane-emissions-livestock-value {
      width: fit-content;
      font-size: 40px;
      font-weight: 700;
      color: #c94b3b;
      background-color: #f2d86a;
      padding: 0 5px;
      border-radius: 10px;
      margin-right: 15px;
    }
    .methane-emissions-livestock-description {
      font-size: 21px;
      font-weight: 600;
      line-height: 1.43;
      max-width: 390px;
    }
  }
  .methane-emissions-info-agriculture-col-2 {
    @media (min-width: 1300px) {
      width: 35%;
      border-left: 1px solid #247775;
    }
  }

  .methane-emissions-cow {
    display: flex;

    @media (max-width: 599px) {
      flex-wrap: wrap;
    }

    .methane-emissions-cow-col-1 {
      display: flex;
      flex-direction: column;
      width: 100%;
      margin-bottom: 40px;

      @media (min-width: 600px) {
        max-width: 180px;
        margin-bottom: 0;
      }

      span {
        font-weight: 600;
      }
      span.description {
        font-size: 23px;
        padding: 0;
        max-width: unset;
        line-height: 1.22;
      }

      span.description-small {
        font-size: 18px;
      }
    }
    .methane-emissions-cow-col-2 {
      width: 100%;
      max-width: 295px;
      margin-right: 15px;

      @media (max-width: 599px) {
        margin: 0 auto 40px;
      }
    }
    .methane-emissions-cow-col-3 {
      display: flex;
      align-items: flex-end;
      width: 100%;

      @media (max-width: 599px) {
        justify-content: center;
      }
    }
  }

  .methane-emissions-cow-wrapper {
    max-width: 295px;
    position: relative;
    container-type: inline-size;

    .methane-emissions-cow-value {
      font-size: clamp(12px, 20cqi, 58px);
      font-weight: 700;
      color: #f2d86a;
      position: absolute;
      top: 5cqi;
      left: 45cqi;
    }
  }

  .methane-emissions-manure {
    display: flex;
    align-items: flex-end;

    .methane-cow-manure-description-wrapper {
      display: flex;
      flex-direction: column;
      max-width: 145px;
      padding-left: 20px;

      span {
        font-weight: 600;
      }
      span.description {
        font-size: 23px;
        line-height: 1.22;
      }
      span.description-small {
        font-size: 18px;
      }
    }
  }

  .methane-emissions-manure-wrapper {
    position: relative;
    width: 55px;
    container-type: inline-size;

    .methane-cow-manure-value {
      position: absolute;
      top: 30cqi;
      left: 20cqi;
      color: #f2d86a;
      font-size: 50cqi;
      font-weight: 700;
    }
  }

  // Methane Emissions Rice & Waste
  .methane-emissions-waste,
  .methane-emissions-rice {
    display: flex;
    padding-left: 40px;

    @media (max-width: 599px) {
      padding-left: 0;
    }
  }

  .methane-emissions-waste-col-1,
  .methane-emissions-rice-col-1 {
    width: 100%;
    max-width: 85px;
  }

  .methane-emissions-waste-col-2,
  .methane-emissions-rice-col-2 {
    padding-left: 20px;
    width: 100%;

    p {
      margin-bottom: 0;
    }
    p,
    span {
      font-size: 20px;
      font-weight: 600;
    }
  }

  .methane-emissions-rice {
    border-bottom: 1px solid #247775;
    padding-bottom: 40px;

    @media (max-width: 599px) {
      padding-top: 40px;
      border-top: 1px solid #247775;
    }
  }
  .methane-emissions-waste {
    padding-top: 40px;
  }

  .methane-emissions-info-energy-waste {
    padding-top: 75px;

    @media (min-width: 550px) {
      padding-top: 50px;
      display: flex;
    }

    .methane-emissions-info-energy-waste-col {
      @media (min-width: 550px) {
        width: 50%;
      }
    }

    .methane-emissions-info-energy-waste-col-1 {
      display: flex;
      margin-bottom: 80px;

      @media (min-width: 550px) {
        padding-right: 60px;
        margin-bottom: 0;
      }

      @media (max-width: 1199px) {
        flex-direction: column;
      }
    }

    .methane-emissions-info-energy-waste-col-2 {
      @media (min-width: 550px) {
        display: flex;
        padding-left: 40px;
        border-left: 1px solid #247775;
      }
    }

    .methane-emissions-info-waste {
      display: flex;

      @media (max-width: 1199px) {
        flex-direction: column;
      }
    }
  }

  // Energy
  .methane-emissions-energy-leaks {
    @media (min-width: 850px) {
      display: flex;
      align-items: flex-end;
      max-width: 370px;
      padding-right: 20px;
    }
    @media (max-width: 549px) {
      align-self: center;
    }
  }
  .methane-emissions-energy-leaks-col {
    width: 50%;
  }
  .methane-emissions-energy-leaks-col-1 {
    width: 100%;
    max-width: 145px;
    position: relative;
    // margin: 0 auto;

    @media (max-width: 549px) {
      margin: 0 auto;
    }

    .methane-emissions-energy-leaks-value {
      font-size: 43px;
      font-weight: 700;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .methane-emissions-energy-leaks-description {
    display: flex;
    flex-direction: column;
    span {
      font-weight: 600;
    }
    span.description {
      font-size: 23px;
      line-height: 1.22;
    }
    span.description-small {
      font-size: 18px;
    }
  }

  .methane-emissions-energy-leaks-col-2 {
    @media (max-width: 849px) {
      width: 100%;
    }
    @media (max-width: 549px) {
      text-align: center;
    }
  }

  .methane-emissions-info-energy-col-1 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (max-width: 1199px) {
      margin-bottom: 60px;
    }
  }
  .methane-emissions-info-energy-col-2 {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;

    @media (max-width: 549px) {
      align-self: center;
    }

    @media (min-width: 1200px) {
      align-self: normal;
    }
  }
  .methane-emissions-energy-burning-fuel-image-wrapper {
    position: relative;
    max-width: 110px;

    @media (max-width: 550px) {
      margin: 0 auto;
    }

    @media (min-width: 1200px) {
      margin: 0 auto;
    }
  }

  .methane-emissions-energy-burning-fuel-value {
    font-size: 29px;
    font-weight: 700;
    color: #ffffff;
    position: absolute;
    bottom: 10px;
    left: 52%;
    transform: translatex(-50%);
  }
  .methane-emissions-energy-burning-fuel-description {
    font-size: 23px;
    font-weight: 600;

    @media (min-width: 1200px) {
      text-align: center;
    }
  }

  .methane-emissions-waste-landfills {
    max-width: 190px;

    @media (max-width: 549px) {
      margin: 0 auto;
    }
  }
  .methane-emissions-waste-landfills-image-wrapper {
    position: relative;
    max-width: 160px;

    @media (max-width: 549px) {
      // margin: 0 auto;
    }
  }
  .methane-emissions-waste-landfills-value {
    font-size: 43px;
    font-weight: 700;
    color: #f2d86a;
    position: absolute;
    right: 7px;
    bottom: 0;
  }
  .methane-emissions-waste-landfills-description {
    font-size: 23px;
    font-weight: 600;
    line-height: 1.22;
  }

  .methane-emissions-info-waste-col-1 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-right: 40px;

    @media (max-width: 1199px) {
      margin-bottom: 60px;
    }
  }
  .methane-emissions-info-waste-col-2 {
    display: flex;
    align-items: flex-end;

    @media (max-width: 799px) {
      flex-direction: column;
      align-items: flex-start;
    }
    @media (max-width: 549px) {
      align-items: center;
    }
  }
  .methane-emissions-wastewater-image-wrapper {
    max-width: 98px;
    width: 100vw;
    position: relative;
  }
  .methane-emissions-wastewater-value {
    font-size: 30px;
    font-weight: 700;
    position: absolute;
    top: 30px;
    left: 53%;
    transform: translatex(-50%);
  }

  .methane-emissions-wastewater-description {
    max-width: 170px;

    @media (min-width: 800px) {
      padding-left: 20px;
    }

    p {
      font-size: 23px;
      font-weight: 600;
      margin-bottom: 20px;
      line-height: 1.2;
    }
    img {
      max-width: 75px;
    }
  }
}

.methane-how {
  background-color: #e8f7f4;
  padding: 50px 20px;

  h2 {
    color: #247775;
  }

  .methane-how-content {
    max-width: 655px;
  }

  .methane-solutions-sector-heading {
    font-size: 23px;
    margin-top: 60px;
  }
}

.methane-explore-sector-buttons-container {
  .v-icon {
    margin-right: 15px;
  }
  .btn-solid {
    color: #ffffff;
    display: flex;
    align-items: center;

    &:hover {
      color: #050505;
    }
  }
  .btn-solid-yellow {
    color: #050505;
  }
  .btn-solid-green:hover {
    background-color: #33a390;
  }

  @media (min-width: 650px) {
    display: flex;
    .btn-solid:not(:last-child) {
      margin-right: 30px;
    }
  }
}
.methane-references {
  padding: 60px 20px 110px;
}

// Map Animation
@keyframes fillAnimation {
  0% {
    height: 0%;
    y: 100%;
  }
  100% {
    height: 60%;
    y: 44%;
  }
}
.active #fillRect {
  animation: fillAnimation 3s forwards;
}

// map container
#map {
  height: 500px !important;
  margin-left: -50px;
  :deep(.mapboxgl-ctrl-logo) {
    display: none !important;
  }
  :deep(h2) {
    font-size: 40px;
    color: #33a390;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  :deep(h4) {
    color: #247775;
  }
}
</style>
